var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _g, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllGames(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 53,
    viewBox: "0 0 59 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2896 41.5278C44.2896 41.5278 45.2681 42.6284 46.7347 41.7257L57.3138 34.9334C57.3138 34.9334 58.0255 34.6799 57.9994 33.8862L55.2852 20.804C55.2852 20.804 55.0357 19.9613 54.0377 19.9969L35.5633 17.8669L22.999 24.9572L44.2874 41.5278H44.2896Z",
    fill: "url(#paint0_linear_1337_9822)",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8384 20.2148L42.5605 26.4247C42.5605 26.4247 41.9009 26.6181 42.0962 27.463L45.7954 42.0682C46.0775 42.037 46.3921 41.937 46.7327 41.7258L57.3118 34.9334C57.3118 34.9334 58.0234 34.68 57.9974 33.8862L55.2832 20.804C55.2832 20.804 55.1769 20.455 54.8362 20.2148H54.8384Z",
    fill: "url(#paint1_linear_1337_9822)",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8046 27.6454L19.9399 25.233L9.76005 32.3344C9.76005 32.3344 8.69477 32.9903 9.21765 33.7929L16.3145 47.0219C16.3145 47.0219 16.6833 48.0735 17.536 48.1914L32.3676 51.9066C32.3676 51.9066 33.537 52.3046 34.3484 51.4575L44.9752 43.0376C44.9752 43.0376 45.6023 42.7041 45.0989 41.5346L39.7747 28.319C39.7747 28.319 39.6423 27.8922 37.8025 27.6476L37.8046 27.6454Z",
    fill: "url(#paint2_linear_1337_9822)",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3505 51.4553L44.9774 43.0354C44.9774 43.0354 45.6044 42.7019 45.101 41.5324L39.7768 28.3168C39.7768 28.3168 39.5338 27.7343 38.6529 27.9344L25.9346 36.4565C25.9346 36.4565 25.2056 36.7856 25.7545 37.6749C26.2079 38.4109 31.4779 48.5138 33.2852 51.9822C33.6302 51.9399 34.0186 51.8021 34.3484 51.4575L34.3505 51.4553Z",
    fill: "url(#paint3_linear_1337_9822)",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3555 1.00965C47.3555 1.00965 48.7353 0.816219 49.0196 2.16135L52.2892 15.8283C52.2892 15.8283 52.4042 17.0356 51.7533 17.438L41.1699 23.5678C41.1699 23.5678 40.7923 23.928 39.6077 23.8568L22.9363 22.0181L18.2781 8.77804C18.2781 8.77804 17.6511 7.73973 18.6622 7.02159L29.4886 1.56771C29.4886 1.56771 30.4324 1.0808 31.6148 1.03855L47.3555 1.01187V1.00965Z",
    fill: "url(#paint4_linear_1337_9822)",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0196 2.16343C48.9154 1.66762 48.6616 1.38303 48.3839 1.21851L36.6418 7.19043C36.6418 7.19043 35.7979 7.37274 36.158 8.19316C36.5182 9.01357 36.0669 8.09978 36.0669 8.09978L41.0267 23.6632C41.1265 23.6121 41.1677 23.5721 41.1677 23.5721L51.7511 17.4423C52.402 17.0399 52.287 15.8326 52.287 15.8326L49.0174 2.16565L49.0196 2.16343Z",
    fill: "url(#paint5_linear_1337_9822)",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8936 21.14L30.2174 7.21068C30.2174 7.21068 30.0243 6.71487 28.3494 6.97723L14.223 8.8404C14.223 8.8404 13.3855 8.89598 12.3679 9.70083L1.37443 17.3625C1.37443 17.3625 0.719204 17.6693 1.14228 18.6765C1.56319 19.6837 7.86161 30.5381 7.86161 30.5381C7.86161 30.5381 8.50599 31.5386 9.28055 31.5097L24.2965 33.0216C24.2965 33.0216 25.1514 33.1305 26.1537 32.2167L37.7634 23.1143C37.7634 23.1143 38.6226 22.4429 37.8936 21.1378V21.14Z",
    fill: "url(#paint6_linear_1337_9822)",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1509 32.219L37.7606 23.1166C37.7606 23.1166 38.6198 22.4452 37.8908 21.1401L30.2146 7.21079C30.2146 7.21079 30.1582 7.07517 29.8653 6.98401L16.815 16.1175C16.815 16.1175 16.3681 17.0313 16.7781 17.6983C17.1101 18.2386 22.8162 28.8662 24.9902 32.9216C25.3113 32.8171 25.717 32.6148 26.1487 32.219H26.1509Z",
    fill: "url(#paint7_linear_1337_9822)",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8326 14.6252C47.8326 14.6252 45.6044 14.1872 45.3722 14.1583C45.2898 14.1472 45.2247 14.1605 45.1748 14.1806C45.1227 14.1983 45.0642 14.2295 45.0077 14.2917C44.8472 14.4651 43.3979 16.2549 43.3979 16.2549C43.3979 16.2549 43.3263 16.3305 43.3415 16.4061C43.3762 16.4751 43.4782 16.4862 43.4782 16.4862C43.4782 16.4862 45.7064 16.9242 45.9385 16.9531C46.021 16.9642 46.086 16.9509 46.1359 16.9308C46.188 16.9131 46.2466 16.8819 46.303 16.8197C46.4636 16.6463 47.9129 14.8565 47.9129 14.8565C47.9129 14.8565 47.9845 14.7809 47.9693 14.7053C47.9346 14.6363 47.8326 14.6252 47.8326 14.6252Z",
    fill: "url(#paint8_linear_1337_9822)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5607 8.53322L43.9287 7.87733C43.9287 7.87733 43.3299 7.69502 43.5165 8.22862L44.7619 11.7882C44.7619 11.7882 44.9007 12.3396 45.4822 12.473L49.2595 13.1845C49.2595 13.1845 49.7412 13.3357 49.5307 12.7376L48.3135 9.26026C48.3135 9.26026 48.1725 8.65551 47.5607 8.53322ZM48.0423 11.199C48.0055 11.3836 47.7625 11.3991 47.7625 11.3991C47.3849 11.4414 46.9358 11.1434 46.9358 11.1434C47.181 11.5592 47.5889 11.8594 47.5889 11.8594L47.6279 11.9727L46.4281 11.7193L46.3999 11.6192C46.7384 11.4147 46.5865 11.0634 46.5865 11.0634C46.3609 11.2146 45.7057 11.1079 45.313 10.6121C44.9202 10.1162 45.454 9.82499 45.454 9.82499C46.0376 9.50705 46.0745 9.06683 46.0745 9.06683C46.0745 9.06683 46.5735 9.69381 47.0248 9.98285C47.4066 10.2274 47.6605 10.4253 47.8449 10.6298C47.9556 10.7544 48.0792 11.0123 48.0423 11.1968V11.199Z",
    fill: "url(#paint9_linear_1337_9822)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47.024 9.98279C46.5727 9.69153 46.0737 9.06677 46.0737 9.06677C46.0737 9.06677 46.0368 9.507 45.4532 9.82494C45.4532 9.82494 44.9195 10.1184 45.3122 10.612C45.7049 11.1078 46.3601 11.2123 46.5858 11.0633C46.5858 11.0633 46.7376 11.4146 46.3992 11.6192L46.4274 11.7192L47.6272 11.9727L47.5881 11.8593C47.5881 11.8593 47.1802 11.5591 46.9351 11.1434C46.9351 11.1434 47.3842 11.4413 47.7617 11.3991C47.7617 11.3991 48.0047 11.3835 48.0416 11.199C48.0785 11.0144 47.9548 10.7565 47.8441 10.632C47.6597 10.4252 47.4059 10.2296 47.024 9.98502V9.98279Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0056 12.0572L42.745 8.50425C42.5563 7.97064 42.2091 8.50425 42.2091 8.50425L39.8247 11.3879C39.4298 11.8837 39.6989 12.4418 39.6989 12.4418L40.9312 15.9147C41.1438 16.5128 41.4194 16.0814 41.4194 16.0814L43.8797 13.0599C44.2442 12.5774 44.0077 12.0616 44.0077 12.0616L44.0056 12.0572ZM42.7168 11.4391C42.6778 11.6859 42.2482 13.3667 42.2482 13.3667C42.2482 13.3667 41.6928 13.6335 41.1395 13.4356C40.5884 13.24 40.7555 12.3529 40.7555 12.3529C40.9073 11.4724 41.5474 11.3991 41.5474 11.3991C41.786 10.2852 42.348 10.4052 42.348 10.4052C42.6734 10.4008 42.7732 11.0633 42.7146 11.4391H42.7168Z",
    fill: "url(#paint10_linear_1337_9822)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1376 13.4314C41.6887 13.6315 42.2463 13.367 42.2463 13.367C42.2463 13.367 42.6824 11.6906 42.7236 11.4415C42.7843 11.0658 42.6867 10.4032 42.3613 10.4055C42.3613 10.4055 41.7993 10.2832 41.5563 11.3949C41.5563 11.3949 40.9163 11.466 40.7601 12.3442C40.7601 12.3442 40.5887 13.2291 41.1398 13.4292L41.1376 13.4314Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.626 22.7407L22.2116 20.7775L21.7061 21.7824L22.1053 23.5522L23.5242 22.6295L23.3116 22.0048L23.3636 22.2493L22.626 22.7407Z",
    fill: "url(#paint11_linear_1337_9822)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2516 19.4613L23.7612 20.4796L24.4794 23.8169L25.3364 24.0058L24.2906 19.408L24.2516 19.4613Z",
    fill: "url(#paint12_linear_1337_9822)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21.624 21.1443C21.624 21.1443 20.9514 21.6112 21.0967 22.5316L21.5936 24.6527L23.581 23.2698L23.6569 23.6166C23.6569 23.6166 23.9672 24.7061 24.848 24.3792L25.3427 24.0346L25.3362 24.0102L24.4792 23.8212L23.7632 20.4839L24.2536 19.4679L24.2926 19.4123L24.2796 19.3567L23.7437 19.7191C23.7437 19.7191 23.0255 20.2171 23.1036 21.0242L23.3141 22.0114L23.5267 22.6361L22.1078 23.5588L21.7086 21.7868L22.2141 20.7841L22.2076 20.7574L21.6261 21.1509L21.624 21.1443Z",
    fill: "url(#paint13_linear_1337_9822)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0088 16.9222L25.6938 18.4874L26.3512 18.4985L27.6617 17.6092C27.6617 17.6092 28.1108 17.2757 28.2236 17.6692C28.3386 18.0628 28.4666 18.6497 28.4666 18.6497C28.4666 18.6497 28.5057 18.9632 28.4363 19.0722C28.4363 19.0722 28.6185 19.2411 28.6879 19.4057C28.7574 19.5702 28.9092 20.4773 28.9092 20.4773C28.9092 20.4773 28.9722 21.022 28.8008 21.549L29.0611 21.3689C29.0611 21.3689 29.7489 20.9843 29.5623 20.1016L29.3714 19.0633C29.3714 19.0633 29.315 18.6898 29.1219 18.6053C29.1219 18.6053 29.1956 18.3518 29.1153 18.0316L28.9353 17.2601C28.9353 17.2601 28.6163 16.4775 28.011 16.9266L28.0088 16.9222Z",
    fill: "url(#paint14_linear_1337_9822)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6618 17.6091L26.3514 18.4984L25.694 18.4873H25.6918C25.6918 18.4873 25.0757 18.8808 25.2188 19.8258L25.4076 20.7018C25.4076 20.7018 25.477 21.082 25.6549 20.9819C25.6549 20.9819 25.5031 21.2332 25.6463 21.7223L25.848 22.5249C25.848 22.5249 25.9652 23.3742 26.8396 22.9162L28.8009 21.5489C28.9745 21.0242 28.9094 20.4772 28.9094 20.4772C28.9094 20.4772 28.7575 19.5701 28.6881 19.4056C28.6187 19.241 28.4364 19.0721 28.4364 19.0721C28.508 18.9609 28.4668 18.6496 28.4668 18.6496C28.4668 18.6496 28.3388 18.0627 28.2238 17.6691C28.1088 17.2756 27.6618 17.6091 27.6618 17.6091ZM28.2281 20.7529L27.1173 21.5222L26.9242 20.6618L28.0112 19.9125L28.2281 20.7529ZM27.8137 18.972L26.7029 19.7324L26.5206 18.9253L27.5881 18.1983L27.8116 18.9742L27.8137 18.972Z",
    fill: "url(#paint15_linear_1337_9822)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8747 21.5711C27.8747 21.5711 27.3474 21.9269 27.0177 22.167C26.6879 22.4071 26.5707 22.0981 26.5707 22.0981L26.4297 21.6134L26.9287 20.6907L27.1153 21.5244L28.2261 20.7552L27.8747 21.5733V21.5711Z",
    fill: "url(#paint16_linear_1337_9822)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4771 19.7925C27.4771 19.7925 26.9738 20.1683 26.6418 20.3662C26.3099 20.5641 26.1623 20.4195 26.1623 20.4195C26.1623 20.4195 26.0126 20.1261 25.9844 19.9415C25.9562 19.757 26.5203 18.9232 26.5203 18.9232L26.7026 19.7303L27.8134 18.9699L27.4793 19.7903L27.4771 19.7925Z",
    fill: "url(#paint17_linear_1337_9822)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2351 14.063L29.1455 16.1529L29.753 16.2885L32.055 14.7255C32.055 14.7255 32.5128 14.3098 32.6321 14.8856L33.2114 17.3024C33.2114 17.3024 33.437 17.9116 32.8729 18.7098L33.0725 18.5719C34.0792 18.0183 33.8644 17.1023 33.8644 17.1023L33.2504 14.4898L32.9684 13.9718C32.7905 13.6205 32.2329 14.0607 32.2329 14.0607L32.2351 14.063Z",
    fill: "#A7A9AC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0549 14.7254L29.7529 16.2884L29.1454 16.1528L29.0825 16.195L29.2908 17.1866L29.6184 16.9643L30.4624 20.3927L32.8729 18.7119C33.437 17.9137 33.2113 17.3045 33.2113 17.3045L32.632 14.8877C32.5301 14.3296 32.0549 14.7276 32.0549 14.7276V14.7254ZM32.6277 17.8003L31.5472 18.5496L31.0157 15.986L32.0007 15.3146L32.6277 17.8003Z",
    fill: "#808285"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0157 15.9861L30.3105 17.0244L30.9593 19.3322L32.2459 18.4384L32.6277 17.8003L31.5451 18.5496L31.0157 15.9861Z",
    fill: "#939598"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M30.311 24.2838C28.5124 25.5644 26.397 25.7579 24.6917 24.9775C24.44 24.8974 24.2968 24.833 24.2925 24.8352C26.0434 25.9936 28.4386 25.9446 30.4369 24.5195C32.3244 23.1721 33.3572 21.1089 33.3073 18.9789C33.2834 19.1656 33.2487 19.3502 33.2075 19.5325C32.9883 21.3734 31.973 23.0988 30.3132 24.2816L30.311 24.2838Z",
    fill: "url(#paint18_linear_1337_9822)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3112 24.2839C31.971 23.101 32.9864 21.3757 33.2055 19.5348C32.815 21.2357 31.6868 22.7386 30.1463 23.9837C27.9572 25.7513 25.6096 25.2666 24.6919 24.9776C26.3972 25.7579 28.5126 25.5667 30.3112 24.2839Z",
    fill: "url(#paint19_linear_1337_9822)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1906 14.8454C23.3595 16.055 22.2399 18.076 22.0729 20.1348C22.0186 20.4238 22.0034 20.595 22.0013 20.5973C21.8928 18.3205 23.0275 15.9549 25.0626 14.6142C26.9849 13.3469 29.0829 13.2535 30.7427 14.2718C30.5843 14.2118 30.4216 14.1607 30.2589 14.1206C28.7032 13.5025 26.8808 13.7293 25.1906 14.8477V14.8454Z",
    fill: "url(#paint20_linear_1337_9822)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M25.19 14.8456C26.8802 13.7295 28.7026 13.5027 30.2583 14.1185C28.7352 13.7361 27.0364 14.1764 25.3506 15.1457C22.9596 16.522 22.2654 19.0855 22.0723 20.1349C22.2393 18.0761 23.3589 16.0551 25.19 14.8456Z",
    fill: "url(#paint21_linear_1337_9822)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.44
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.4468 30.478C51.8306 31.3118 51.6614 31.692 51.6614 31.692C51.3316 32.3412 51.657 33.2772 51.657 33.2772C51.9369 32.3968 52.2537 31.9721 52.2537 31.9721C52.5336 31.6364 52.59 31.483 52.59 31.483C52.6919 31.3296 52.7983 30.7137 52.7983 30.7137C52.9957 31.7142 52.7635 31.9388 52.6659 32.1166C52.5683 32.2945 52.2428 33.1572 52.2428 33.1572C52.6204 32.3323 53.3407 32.2478 53.3407 32.2478C53.473 29.731 52.6138 29.104 52.6138 29.104C52.8612 29.9689 52.4446 30.4758 52.4446 30.4758L52.4468 30.478Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8967 27.1497C54.8967 27.1497 55.0334 28.0947 54.7492 28.1836C54.4628 28.2725 54.1894 28.3281 53.9312 28.1992C53.673 28.0702 53.0482 27.6189 52.5643 27.6611C52.0783 27.7034 51.9286 27.6322 51.8527 27.4921C51.7789 27.3521 51.6444 26.2804 52.4559 26.336C52.4559 26.336 52.6728 26.4138 52.688 26.4872C52.688 26.4872 52.8247 26.0736 52.0718 25.7957C52.0718 25.7957 52.2931 25.6112 52.7878 25.4622C52.7878 25.4622 53.0634 25.3444 52.892 25.5867L52.5123 25.8535C52.5123 25.8535 53.3302 26.4183 53.762 26.3115C53.762 26.3115 53.1458 25.9447 53.059 25.7979C52.9722 25.6512 53.0265 25.5823 53.1154 25.5356C53.2044 25.4889 53.5754 25.1309 53.5754 25.1309C53.5754 25.1309 52.6121 25.1954 52.4797 25.0998C52.4797 25.0998 51.7486 24.942 51.5359 24.7885C51.5359 24.7885 51.1845 24.4706 50.5726 24.7685C50.5726 24.7685 50.1712 25.102 49.8588 25.2732C49.644 25.3911 49.2231 25.1754 49.3034 25.3177C49.3034 25.3177 49.4357 25.6423 49.6614 25.6112C49.6614 25.6112 49.0517 25.769 49.286 26.5895C49.286 26.5895 49.4206 26.127 49.6353 26.1981C49.848 26.2693 50.347 26.3182 50.4229 27.3343C50.4229 27.3343 50.3991 29.1219 49.4921 28.257C49.4921 28.257 49.5117 29.0552 50.2645 28.8751C50.2645 28.8751 50.4338 27.7723 50.9588 28.0191C51.4795 28.2659 51.8071 28.8017 51.8071 28.8017C51.8071 28.8017 51.2192 28.3148 50.7679 28.4793C50.7679 28.4793 51.6271 28.7617 51.0044 29.6488C51.0044 29.6488 50.1821 30.8827 50.4576 31.9455C50.7332 33.0083 50.705 32.8793 50.705 32.8793C50.705 32.8793 50.9024 31.6431 51.102 31.3408C51.3016 31.0384 51.7572 30.6582 51.7572 30.6582C51.7572 30.6582 52.4103 29.9467 52.4385 29.2775C52.4385 29.2775 52.4754 28.9106 52.2519 28.5127C52.176 28.377 52.0697 28.2347 51.9221 28.1036C51.9221 28.1036 52.9679 28.0502 53.404 29.9956C53.404 29.9956 53.7403 29.4843 54.7296 30.0779C54.7296 30.0779 54.786 29.9267 54.5647 29.6999C54.3434 29.4731 54.1634 29.3975 54.1243 29.0974C54.0852 28.795 54.3673 28.8951 54.3673 28.8951C54.3673 28.8951 54.901 29.1107 55.1505 30.0668L55.3501 30.6738C55.3501 30.6738 55.4651 29.7577 55.4326 29.2686C55.3979 28.7817 55.2221 27.7967 54.8945 27.1431L54.8967 27.1497ZM49.9695 25.4222C49.9695 25.4222 50.3014 25.5245 50.5119 25.291C50.5119 25.291 50.2732 25.9491 49.9695 25.4222Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9927 27.8123C48.3138 27.5322 48.5199 27.7901 48.572 27.8479C48.6241 27.9057 48.7217 28.0614 48.7304 28.7617C48.7412 29.4621 48.9864 29.6555 48.9864 29.6555C48.9864 29.6555 49.2012 29.76 49.2424 29.8245C49.2815 29.8867 49.2316 29.9601 49.2316 29.9601C49.2316 29.9601 49.3531 29.8289 49.5071 29.8956C49.5071 29.8956 49.3335 29.7111 49.1036 29.5554C48.8736 29.3998 48.8497 28.7106 48.8649 28.4504C48.8801 28.1903 48.789 27.7034 48.6067 27.5478C48.4223 27.3899 47.971 27.3988 47.7063 27.9413C47.7063 27.9413 47.5458 28.4126 47.7324 28.824C47.7324 28.824 47.6673 28.0947 47.9905 27.8123H47.9927Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9252 30.7448C49.9013 30.9248 49.8384 31.2072 49.769 31.394C49.6995 31.5807 49.5889 31.4251 49.5889 31.4251C49.5065 31.3717 49.3264 31.4073 49.3264 31.4073C49.3264 31.4073 49.3915 31.454 49.3893 31.6963C49.3871 31.9387 48.9076 31.5807 48.9076 31.5807L48.7861 31.9276C48.964 31.912 49.0009 32.041 49.0053 32.1032C49.0118 32.1655 48.9423 32.3611 48.9423 32.3611C49.3741 31.9654 49.5108 32.1944 49.5542 32.2455C49.5976 32.2967 49.7126 32.4256 49.7126 32.4256C49.7126 32.4256 49.7646 32.2411 49.7798 32.1744C49.795 32.1077 49.9512 31.7008 50.0315 31.3984C50.1139 31.096 49.923 30.747 49.923 30.747L49.9252 30.7448Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3814 32.3813C48.3814 32.3813 48.1297 33.0794 48.4031 33.4863C48.6743 33.891 49.0041 33.8732 49.2666 33.7064C49.5291 33.5397 49.7092 33.0794 49.6636 32.866C49.6181 32.6526 49.4836 32.468 49.0431 32.5369C49.0431 32.5369 49.4792 32.6281 49.4988 32.866C49.4988 32.866 49.5964 33.3529 49.1104 33.5375C49.1104 33.5375 48.7264 33.6597 48.594 33.344C48.4617 33.0283 48.3749 32.9371 48.5137 32.4591C48.6526 31.9811 48.9043 31.3697 48.9043 31.3697C48.9043 31.3697 49.0453 31.2563 48.9021 30.925C48.9021 30.925 49.0106 31.1362 49.054 31.1118L49.0952 31.0895C49.0952 31.0895 49.208 31.2141 49.2232 31.1763C49.2384 31.1407 49.2059 31.0273 49.2579 30.9384C49.31 30.8494 49.4489 30.7005 49.5834 30.8116C49.5834 30.8116 49.54 30.5759 49.4532 30.5671C49.3664 30.5582 49.4272 30.3403 49.4272 30.3403C49.4272 30.3403 49.4228 30.1024 49.6354 30.1446C49.6354 30.1446 49.4272 29.8667 49.2514 30.0357C49.0757 30.2046 48.9607 30.1824 48.9607 30.1824C48.9607 30.1824 48.824 30.1713 48.7133 30.3158L48.492 30.2113C48.492 30.2113 48.5984 30.0423 48.5029 29.9712C48.4074 29.9001 48.1406 29.8378 48.1406 29.8378C48.1406 29.8378 47.9453 29.1997 47.3595 29.0863C47.3595 29.0863 47.6763 29.5043 47.5201 29.4821C47.3638 29.4598 47.0124 29.193 46.5459 29.571L47.0926 29.6599C47.0926 29.6599 47.3313 29.6466 47.097 29.8267C46.8627 30.009 46.6045 29.9845 46.3506 30.3758C46.0946 30.7694 45.7431 31.6187 45.7431 31.6187C45.7431 31.6187 46.5871 30.7049 46.4786 31.0273C46.3723 31.3497 45.0749 33.0216 45.4784 34.1333C45.4784 34.1333 45.8321 33.1417 46.0013 32.9438C46.0013 32.9438 46.1272 32.7415 46.1163 32.8704C46.1163 32.8704 46.1597 32.8838 46.0924 33.1306C46.0924 33.1306 45.3005 34.6669 46.0599 35.5296C46.0599 35.5296 45.9232 35.0404 46.0729 34.8981C46.2226 34.7559 46.4287 35.0938 46.4287 35.0938C46.4287 35.0938 47.6784 37.2238 50.4989 36.7902C50.4989 36.7902 49.0627 36.7324 48.0646 35.8564C48.0646 35.8564 46.6631 34.7158 47.2532 32.677C47.2532 32.677 47.0709 32.946 47.021 33.0861C47.021 33.0861 46.9212 33.1884 46.8995 33.2662L46.8757 33.344C46.8757 33.344 46.8388 33.2151 46.8909 33.0439C46.9429 32.8749 46.8605 32.7593 47.3053 32.1479C47.3053 32.1479 47.5374 31.8144 47.6242 32.1323C47.711 32.4502 47.5049 32.826 47.8412 33.5463C47.8412 33.5463 47.7848 32.717 48.3727 32.1879L48.607 31.5186C48.607 31.5186 48.0711 31.7921 48.0777 31.6765C48.0777 31.6765 48.1492 31.5631 48.2274 31.4875C48.3055 31.4119 48.4183 31.2674 48.4183 31.2674C48.4183 31.2674 48.5593 31.1162 48.6157 31.1229C48.6721 31.1296 48.722 31.1385 48.722 31.1385C48.722 31.1385 48.7763 31.0629 48.7112 30.9762C48.7112 30.9762 48.8782 30.9139 48.7741 31.2674L48.3814 32.368V32.3813ZM48.0191 30.3625C48.0191 30.3625 47.98 30.298 48.0364 30.2891C48.0907 30.2802 48.1406 30.2602 48.1102 30.2069C48.0798 30.1535 48.0863 30.0846 48.0863 30.0846C48.0863 30.0846 48.2339 30.1735 48.2577 30.3091C48.2816 30.4448 48.1709 30.4959 48.1709 30.4959C48.1709 30.4959 48.1037 30.616 48.0017 30.5871C47.8997 30.5582 47.6741 30.5493 47.5895 30.8161C47.5895 30.8161 47.4918 30.6738 47.7197 30.5293C47.7197 30.5293 47.8238 30.487 47.9084 30.5048C47.993 30.5226 48.0603 30.4937 48.0733 30.4648C48.0885 30.4359 48.121 30.3959 48.0169 30.3603L48.0191 30.3625ZM47.225 30.5204C47.225 30.5204 47.2922 30.4492 47.2727 30.2336C47.2532 30.0179 46.6869 30.2847 46.6869 30.2847C47.2792 29.7177 47.8867 30.3292 47.8867 30.3292C47.5591 30.2291 47.3248 30.4826 47.3248 30.4826C47.1404 30.7449 47.2228 30.9472 47.2228 30.9472C47.3335 31.2341 47.7023 31.014 47.7023 31.014C47.1859 31.7099 47.0688 31.1807 47.0666 31.0384C47.0666 30.8983 46.8692 30.9962 46.6782 31.2341C46.4873 31.472 46.0989 32.3368 46.0989 32.3368C46.5025 30.8828 47.2272 30.5226 47.2272 30.5226L47.225 30.5204ZM46.5763 32.6681C46.5763 32.6681 46.6457 32.7348 46.7043 32.697C46.7629 32.657 46.7477 32.7504 46.6761 32.8393C46.6045 32.9283 46.4179 33.8443 46.8106 34.0355C46.8106 34.0355 46.5437 34.1 46.4135 33.5197C46.4135 33.5197 46.3832 33.224 46.3745 33.1573C46.3658 33.0906 46.3116 33.0439 46.2725 33.115C46.2335 33.1862 46.2074 33.1217 46.2161 33.0328C46.227 32.9416 46.3853 32.1745 47.0709 31.801C47.0709 31.801 46.3506 32.3702 46.5763 32.6659V32.6681ZM47.8303 31.7988C47.9301 32.2212 47.7696 32.4502 47.7696 32.4502C47.7696 32.4502 47.8216 32.3368 47.6936 31.8321C47.5634 31.3252 47.0406 32.1879 47.0406 32.1879C47.5135 30.965 48.2013 31.2252 48.2013 31.2252C48.2013 31.2252 47.7457 31.4386 47.8303 31.7988ZM48.3901 30.9117C48.1709 31.0295 47.9171 30.9917 47.9171 30.9917L48.3532 30.5537C48.3532 30.5537 48.4378 30.4159 48.4747 30.4892C48.5094 30.5604 48.6092 30.7938 48.3901 30.9139V30.9117Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5244 34.9136C48.5244 34.9136 50.0019 35.405 50.9587 34.7513C50.9587 34.7513 51.039 34.987 51.1518 35.0115C51.1518 35.0115 50.0128 35.8186 48.5244 34.9136Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0845 34.698C51.0845 34.698 51.8438 34.0421 52.1541 33.5018C52.1541 33.5018 52.204 33.8798 52.4926 33.9932C52.4926 33.9932 51.7267 34.698 51.3101 34.9248C51.3101 34.9248 51.1474 34.9515 51.0845 34.698Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2233 33.4062C52.2233 33.4062 52.1799 33.7686 52.4901 33.7752L52.6463 33.8775C52.6463 33.8775 53.2235 33.3906 53.4665 33.3417C53.4665 33.3417 53.2083 32.7103 53.8483 32.4768C53.8483 32.4768 52.9761 32.2745 52.2254 33.4062H52.2233Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0201 32.4946C54.0201 32.4946 53.4886 32.6014 53.4907 33.0683L53.5406 33.3084C53.5406 33.3084 54.4736 32.9838 54.2284 34.0688C54.2284 34.0688 54.645 33.5063 54.5842 33.1327C54.5235 32.7592 54.402 32.4546 54.0201 32.4946Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2641 35.0627C48.2641 35.0627 49.6288 35.7008 50.3665 35.4717C50.3665 35.4717 50.9132 35.434 51.7724 34.7714C52.6229 34.1155 52.6815 34.0466 52.6815 34.0466C52.6815 34.0466 53.4278 33.4085 53.7294 33.404C53.7294 33.404 54.1156 33.3151 54.2024 33.6997C54.2892 34.0844 53.6448 35.0249 53.6448 35.0249C53.6448 35.0249 52.8247 36.2255 51.716 36.5856C51.716 36.5856 52.5274 35.8186 52.3604 35.6296C52.1933 35.4406 51.6661 35.7474 51.6661 35.7474C51.6661 35.7474 50.9045 36.2588 49.9304 36.0587C49.0256 35.8742 48.2598 35.0627 48.2598 35.0627H48.2641Z",
    fill: "#231F20"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5647 30.4135C51.9507 31.2451 51.7815 31.6275 51.7815 31.6275C51.4517 32.2767 51.7772 33.2127 51.7772 33.2127C52.057 32.3323 52.3738 31.9098 52.3738 31.9098C52.6537 31.5741 52.7101 31.4229 52.7101 31.4229C52.8121 31.2695 52.9184 30.6559 52.9184 30.6559C53.1158 31.6542 52.8837 31.8809 52.786 32.0566C52.6884 32.2345 52.363 33.0949 52.363 33.0949C52.7405 32.27 53.4586 32.1855 53.4586 32.1855C53.591 29.6709 52.734 29.0439 52.734 29.0439C52.9813 29.9088 52.5647 30.4158 52.5647 30.4158V30.4135Z",
    fill: "#F68C20"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0116 27.0895C55.0116 27.0895 55.1483 28.0344 54.8641 28.1234C54.5777 28.2123 54.3043 28.2679 54.0483 28.1389C53.7901 28.0077 53.1674 27.5586 52.6836 27.5987C52.1976 27.6387 52.0479 27.5698 51.9741 27.4297C51.9004 27.2896 51.7658 26.2202 52.5773 26.2735C52.5773 26.2735 52.7942 26.3514 52.8094 26.4247C52.8094 26.4247 52.9461 26.0112 52.1954 25.7333C52.1954 25.7333 52.4167 25.5487 52.9114 25.402C52.9114 25.402 53.1869 25.2841 53.0155 25.5265L52.6359 25.7933C52.6359 25.7933 53.4538 26.358 53.8834 26.2535C53.8834 26.2535 53.2672 25.8867 53.1826 25.7399C53.098 25.5932 53.1501 25.5243 53.239 25.4776C53.328 25.4309 53.699 25.0751 53.699 25.0751C53.699 25.0751 52.7357 25.1396 52.6055 25.044C52.6055 25.044 51.8765 24.8839 51.6617 24.7328C51.6617 24.7328 51.3102 24.4148 50.6984 24.7127C50.6984 24.7127 50.2992 25.044 49.9846 25.2152C49.7698 25.3331 49.3489 25.1174 49.4313 25.2597C49.4313 25.2597 49.5637 25.5843 49.7893 25.5532C49.7893 25.5532 49.1796 25.711 49.414 26.5292C49.414 26.5292 49.5485 26.0668 49.7633 26.1401C49.9781 26.2135 50.4727 26.2602 50.5508 27.2763C50.5508 27.2763 50.527 29.0616 49.6222 28.1967C49.6222 28.1967 49.6418 28.9949 50.3946 28.8148C50.3946 28.8148 50.5639 27.712 51.0867 27.9611C51.6053 28.2079 51.9351 28.7437 51.9351 28.7437C51.9351 28.7437 51.3493 28.2568 50.898 28.4213C50.898 28.4213 51.7572 28.7037 51.1345 29.5908C51.1345 29.5908 50.3144 30.8247 50.5877 31.8875C50.8611 32.9503 50.8351 32.8213 50.8351 32.8213C50.8351 32.8213 51.0303 31.5851 51.2299 31.2827C51.4295 30.9804 51.883 30.6024 51.883 30.6024C51.883 30.6024 52.5361 29.8932 52.5643 29.2239C52.5643 29.2239 52.6011 28.8571 52.3777 28.4591C52.3017 28.3235 52.1954 28.1834 52.0479 28.05C52.0479 28.05 53.0915 27.9989 53.5254 29.9421C53.5254 29.9421 53.8617 29.4329 54.8489 30.0243C54.8489 30.0243 54.9053 29.8731 54.684 29.6464C54.4627 29.4196 54.2848 29.344 54.2436 29.0438C54.2045 28.7437 54.4865 28.8437 54.4865 28.8437C54.4865 28.8437 55.0203 29.0594 55.2676 30.0154L55.465 30.6224C55.465 30.6224 55.58 29.7064 55.5475 29.2195C55.5128 28.7326 55.337 27.7476 55.0116 27.094V27.0895ZM50.0909 25.3597C50.0909 25.3597 50.4228 25.462 50.6333 25.2286C50.6333 25.2286 50.3968 25.8867 50.0909 25.3597Z",
    fill: "#F68C20"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1185 27.7479C48.4396 27.4677 48.6457 27.7279 48.6956 27.7834C48.7477 27.8412 48.8453 27.9969 48.854 28.6972C48.8648 29.3954 49.11 29.591 49.11 29.591C49.11 29.591 49.3248 29.6955 49.366 29.76C49.4051 29.8222 49.3552 29.8956 49.3552 29.8956C49.3552 29.8956 49.4767 29.7667 49.6307 29.8311C49.6307 29.8311 49.4571 29.6466 49.2293 29.491C48.9993 29.3353 48.9755 28.6483 48.9907 28.3882C49.0058 28.1281 48.9169 27.6434 48.7325 27.4855C48.5481 27.3276 48.0989 27.3365 47.8342 27.879C47.8342 27.879 47.6737 28.3504 47.8603 28.7595C47.8603 28.7595 47.7974 28.0302 48.1185 27.7501V27.7479Z",
    fill: "#B32025"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0495 30.6781C50.0256 30.8582 49.9627 31.1406 49.8933 31.3273C49.8238 31.5141 49.7132 31.3562 49.7132 31.3562C49.6307 31.3029 49.4507 31.3384 49.4507 31.3384C49.4507 31.3384 49.5158 31.3851 49.5136 31.6275C49.5114 31.8698 49.0341 31.5119 49.0341 31.5119L48.9126 31.8565C49.0905 31.8431 49.1274 31.9699 49.1317 32.0321C49.1382 32.0944 49.0688 32.29 49.0688 32.29C49.5006 31.8943 49.6373 32.1233 49.6785 32.1744C49.7197 32.2256 49.8369 32.3545 49.8369 32.3545C49.8369 32.3545 49.8868 32.17 49.9041 32.1055C49.9215 32.041 50.0733 31.6341 50.1558 31.3295C50.2382 31.0272 50.0473 30.6781 50.0473 30.6781H50.0495Z",
    fill: "#B32025"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5053 32.3124C48.5053 32.3124 48.2536 33.0105 48.5248 33.4174C48.796 33.822 49.1236 33.8042 49.3861 33.6375C49.6486 33.4707 49.8287 33.0105 49.7832 32.7971C49.7376 32.5836 49.6031 32.3991 49.1627 32.468C49.1627 32.468 49.5987 32.5592 49.6183 32.7971C49.6183 32.7971 49.7159 33.284 49.2299 33.4663C49.2299 33.4663 48.8459 33.5886 48.7135 33.2729C48.5812 32.9571 48.4944 32.866 48.6333 32.388C48.7721 31.9122 49.0238 31.2985 49.0238 31.2985C49.0238 31.2985 49.1648 31.1851 49.0216 30.8538C49.0216 30.8538 49.1301 31.0651 49.1735 31.0406L49.2147 31.0184C49.2147 31.0184 49.3275 31.1429 49.3427 31.1051C49.3579 31.0695 49.3254 30.9561 49.3774 30.8672C49.4295 30.7783 49.5684 30.6293 49.7029 30.7405C49.7029 30.7405 49.6595 30.5048 49.5727 30.4959C49.4859 30.487 49.5467 30.2691 49.5467 30.2691C49.5467 30.2691 49.5423 30.0312 49.755 30.0735C49.755 30.0735 49.5467 29.7955 49.3731 29.9645C49.1974 30.1335 49.0824 30.1112 49.0824 30.1112C49.0824 30.1112 48.9457 30.1001 48.835 30.2446L48.6137 30.1402C48.6137 30.1402 48.72 29.9712 48.6246 29.9C48.5291 29.8289 48.2623 29.7666 48.2623 29.7666C48.2623 29.7666 48.067 29.1285 47.4812 29.0151C47.4812 29.0151 47.798 29.4309 47.6396 29.4109C47.4812 29.3909 47.1341 29.1219 46.6676 29.4998L47.2143 29.5888C47.2143 29.5888 47.453 29.5754 47.2187 29.7555C46.9843 29.9356 46.7283 29.9111 46.4723 30.3025C46.2163 30.6938 45.867 31.5431 45.867 31.5431C45.867 31.5431 46.7088 30.6315 46.6025 30.9539C46.4962 31.2763 45.2009 32.946 45.6023 34.0577C45.6023 34.0577 45.9559 33.0661 46.1252 32.8704C46.1252 32.8704 46.251 32.6681 46.2402 32.7971C46.2402 32.7971 46.2836 32.8104 46.2163 33.055C46.2163 33.055 45.4266 34.5891 46.1838 35.4517C46.1838 35.4517 46.0471 34.9626 46.1968 34.8225C46.3465 34.6825 46.5526 35.0182 46.5526 35.0182C46.5526 35.0182 47.8001 37.1482 50.6141 36.7168C50.6141 36.7168 49.18 36.659 48.1841 35.783C48.1841 35.783 46.7847 34.6424 47.3749 32.6058C47.3749 32.6058 47.1926 32.8749 47.1427 33.0149C47.1427 33.0149 47.0429 33.1172 47.0212 33.195L46.9974 33.2729C46.9974 33.2729 46.9605 33.1439 47.0126 32.9727C47.0646 32.8037 46.9822 32.6881 47.427 32.0789C47.427 32.0789 47.6591 31.7454 47.7459 32.0634C47.8327 32.3813 47.6266 32.757 47.9628 33.4774C47.9628 33.4774 47.9086 32.6481 48.4922 32.1212L48.7266 31.4519C48.7266 31.4519 48.1907 31.7254 48.1972 31.6098C48.1972 31.6098 48.2688 31.4964 48.3469 31.4208C48.425 31.3452 48.5378 31.2007 48.5378 31.2007C48.5378 31.2007 48.6788 31.0495 48.7352 31.0562C48.7916 31.0628 48.8415 31.0717 48.8415 31.0717C48.8415 31.0717 48.8958 30.9961 48.8307 30.9094C48.8307 30.9094 48.9978 30.8472 48.8936 31.2007L48.5009 32.3012L48.5053 32.3124ZM48.1451 30.2958C48.1451 30.2958 48.1082 30.2313 48.1625 30.2224C48.2167 30.2135 48.2666 30.1935 48.2362 30.1402C48.2058 30.0868 48.2124 30.0201 48.2124 30.0201C48.2124 30.0201 48.3599 30.109 48.3838 30.2446C48.4076 30.3803 48.297 30.4314 48.297 30.4314C48.297 30.4314 48.2297 30.5515 48.1277 30.5226C48.0258 30.4937 47.8001 30.4848 47.7155 30.7516C47.7155 30.7516 47.6179 30.6093 47.8435 30.4648C47.8435 30.4648 47.9477 30.4225 48.0323 30.4403C48.1169 30.4581 48.182 30.4292 48.1972 30.4003C48.2124 30.3714 48.2449 30.3314 48.1408 30.2958H48.1451ZM47.3532 30.4536C47.3532 30.4536 47.4204 30.3825 47.4009 30.1668C47.3814 29.9512 46.8151 30.218 46.8151 30.218C47.4074 29.6532 48.0127 30.2624 48.0127 30.2624C47.6851 30.1624 47.4508 30.4158 47.4508 30.4158C47.2664 30.676 47.3488 30.8805 47.3488 30.8805C47.4595 31.1651 47.8262 30.9472 47.8262 30.9472C47.312 31.6409 47.1926 31.1118 47.1926 30.9717C47.1926 30.8316 46.9952 30.9294 46.8043 31.1673C46.6133 31.4052 46.225 32.2679 46.225 32.2679C46.6285 30.8161 47.351 30.4559 47.351 30.4559L47.3532 30.4536ZM46.7066 32.5992C46.7066 32.5992 46.7761 32.6659 46.8346 32.6281C46.8932 32.5881 46.878 32.6814 46.8064 32.7704C46.7348 32.8593 46.5483 33.7753 46.941 33.9665C46.941 33.9665 46.6741 34.031 46.5439 33.4529C46.5439 33.4529 46.5135 33.1572 46.5049 33.0928C46.4962 33.0261 46.4419 32.9794 46.4029 33.0505C46.3638 33.1217 46.3378 33.0572 46.3465 32.9683C46.3573 32.8771 46.5157 32.11 47.1991 31.7387C47.1991 31.7387 46.4788 32.3079 46.7045 32.6014L46.7066 32.5992ZM47.9585 31.7321C48.0583 32.1545 47.8978 32.3835 47.8978 32.3835C47.8978 32.3835 47.9498 32.2701 47.8218 31.7654C47.6916 31.2585 47.1709 32.1212 47.1709 32.1212C47.6439 30.9005 48.3295 31.1607 48.3295 31.1607C48.3295 31.1607 47.8739 31.3741 47.9585 31.7343V31.7321ZM48.5161 30.8472C48.297 30.965 48.0453 30.9272 48.0453 30.9272L48.4792 30.4892C48.4792 30.4892 48.5638 30.3514 48.6007 30.4247C48.6354 30.4959 48.7352 30.7293 48.5161 30.8472Z",
    fill: "#B32025"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6475 34.8425C48.6475 34.8425 50.1228 35.3338 51.0774 34.6824C51.0774 34.6824 51.1577 34.918 51.2705 34.9425C51.2705 34.9425 50.1337 35.7474 48.6475 34.8425Z",
    fill: "#B32025"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2061 34.6268C51.2061 34.6268 51.9654 33.9731 52.2735 33.4329C52.2735 33.4329 52.3234 33.8108 52.6098 33.9242C52.6098 33.9242 51.8461 34.6268 51.4295 34.8536C51.4295 34.8536 51.2668 34.8803 51.2061 34.6268Z",
    fill: "#B32025"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3429 33.3395C52.3429 33.3395 52.2995 33.7019 52.6076 33.7086L52.7638 33.8109C52.7638 33.8109 53.3409 33.3262 53.5818 33.2751C53.5818 33.2751 53.3236 32.6436 53.9636 32.4124C53.9636 32.4124 53.0936 32.2101 52.3429 33.3395Z",
    fill: "#B32025"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1353 32.4279C54.1353 32.4279 53.606 32.5346 53.606 32.9993L53.6559 33.2394C53.6559 33.2394 54.5866 32.9148 54.3436 33.9998C54.3436 33.9998 54.7602 33.4373 54.6973 33.066C54.6344 32.6925 54.515 32.3901 54.1353 32.4279Z",
    fill: "#B32025"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3882 34.9913C48.3882 34.9913 49.7507 35.6294 50.4884 35.4004C50.4884 35.4004 51.0351 35.3626 51.8921 34.7001C52.7405 34.0464 52.8012 33.9753 52.8012 33.9753C52.8012 33.9753 53.5454 33.3394 53.847 33.3349C53.847 33.3349 54.2332 33.246 54.3199 33.6306C54.4067 34.0153 53.7645 34.9535 53.7645 34.9535C53.7645 34.9535 52.9466 36.1519 51.8401 36.5121C51.8401 36.5121 52.6515 35.7451 52.4823 35.5561C52.313 35.3671 51.7902 35.6739 51.7902 35.6739C51.7902 35.6739 51.0308 36.1831 50.0566 35.9852C49.1541 35.8006 48.3882 34.9891 48.3882 34.9891V34.9913Z",
    fill: "#B32025"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5125 44.307C32.8486 43.8801 32.278 43.2309 31.8918 42.3838C30.7202 39.8181 31.6684 36.5275 33.9595 35.1379C35.7017 34.0796 37.6717 34.4709 38.9171 35.885L39.8066 34.5043C38.1555 32.6789 35.5759 32.1586 33.2652 33.5238C30.1344 35.3758 28.8348 39.847 30.4534 43.3221C30.8656 44.2048 31.4232 44.9251 32.0741 45.4654L33.5125 44.307Z",
    fill: "#111D2A"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5406 45.3654C31.8159 44.8362 31.1932 44.0847 30.7528 43.1331C29.2341 39.8581 30.4556 35.6449 33.4019 33.8929C35.5455 32.6167 37.9408 33.0636 39.5072 34.7178L39.6244 34.6444C38.0254 32.9191 35.5542 32.441 33.3412 33.755C30.321 35.5471 29.0692 39.8626 30.627 43.2154C31.0782 44.187 31.7139 44.9541 32.4538 45.4943L32.5384 45.3654H32.5406Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7249 44.6962C32.1369 44.2248 31.6358 43.5867 31.2713 42.7952C29.9152 39.847 31.0087 36.0607 33.6513 34.4732C35.6496 33.2726 37.8995 33.7328 39.3162 35.3536L39.6851 34.8289C38.1099 33.028 35.6083 32.5078 33.3758 33.8351C30.3991 35.6027 29.1667 39.8582 30.7006 43.1665C31.0977 44.0225 31.6379 44.7162 32.2693 45.2342L32.7249 44.6962Z",
    fill: "url(#paint22_linear_1337_9822)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9655 44.5561L33.0848 44.396C32.4968 43.9513 31.9956 43.3332 31.6377 42.5529C30.3945 39.8404 31.399 36.3564 33.8268 34.889C35.7057 33.7528 37.8319 34.2086 39.1381 35.7783L39.2661 35.3937C37.8645 33.7995 35.645 33.3504 33.6749 34.5354C31.0649 36.1051 29.9822 39.8448 31.3231 42.7574C31.7093 43.5956 32.2517 44.2604 32.8874 44.7362L32.9655 44.5539V44.5561Z",
    fill: "url(#paint23_linear_1337_9822)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2823 34.6335C33.3929 34.5557 33.5057 34.4801 33.6229 34.4111C34.6036 33.8219 35.6471 33.6285 36.6213 33.773L36.7406 33.2194C35.658 33.0416 34.4951 33.2439 33.3994 33.8931C33.241 33.9865 33.087 34.0887 32.9395 34.1977L33.2823 34.6312V34.6335Z",
    fill: "url(#paint24_linear_1337_9822)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1346 44.2404C31.7744 43.8447 31.4598 43.3756 31.2125 42.8331C30.9044 42.1661 30.7221 41.4524 30.6549 40.7253L30.1255 40.7053C30.1906 41.5435 30.3945 42.3684 30.7503 43.1354C31.0215 43.7202 31.36 44.2271 31.7505 44.6562L32.1346 44.2404Z",
    fill: "url(#paint25_linear_1337_9822)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2137 44.8809C32.4609 44.4073 31.8187 43.6803 31.3782 42.7264C30.0547 39.8472 31.1222 36.1498 33.7019 34.5979C35.5114 33.5084 37.5356 33.813 38.9242 35.1248L39.0023 35.0292C37.5833 33.6774 35.507 33.3595 33.6498 34.4756C31.0072 36.0631 29.9116 39.8494 31.2697 42.7976C31.7188 43.7736 32.3784 44.5162 33.1465 45.0009L33.2137 44.8809Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M33.4886 34.2865C33.5407 34.2554 33.5624 34.1798 33.5363 34.1198C33.5103 34.0597 33.4474 34.0353 33.3931 34.0664C33.3389 34.0975 33.3194 34.1731 33.3454 34.2332C33.3714 34.2932 33.4365 34.3176 33.4886 34.2865Z",
    fill: "#231F20"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4798 34.2688C33.5319 34.2377 33.5536 34.1621 33.5275 34.1021C33.5015 34.042 33.4386 34.0176 33.3844 34.0487C33.3301 34.0798 33.3106 34.1554 33.3366 34.2155C33.3627 34.2755 33.4277 34.2999 33.4798 34.2688Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M34.1745 33.9374C34.2266 33.9062 34.2483 33.8329 34.2223 33.7728C34.1962 33.7128 34.1333 33.6884 34.0812 33.7195C34.0292 33.7506 34.0075 33.824 34.0335 33.8862C34.0595 33.9485 34.1224 33.9707 34.1745 33.9396V33.9374Z",
    fill: "#231F20"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1657 33.9175C34.2178 33.8863 34.2395 33.813 34.2135 33.7529C34.1874 33.6929 34.1245 33.6685 34.0724 33.6996C34.0204 33.7307 33.9987 33.8041 34.0247 33.8663C34.0507 33.9286 34.1137 33.9508 34.1657 33.9197V33.9175Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M34.8662 33.7041C34.9183 33.673 34.9378 33.5996 34.914 33.5396C34.8901 33.4795 34.8272 33.4551 34.7751 33.4862C34.723 33.5173 34.7035 33.5907 34.7274 33.6507C34.7512 33.7108 34.8163 33.7352 34.8662 33.7041Z",
    fill: "#231F20"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8579 33.6861C34.91 33.655 34.9295 33.5817 34.9057 33.5216C34.8818 33.4616 34.8189 33.4371 34.7668 33.4683C34.7147 33.4994 34.6952 33.5728 34.7191 33.6328C34.7429 33.6928 34.808 33.7173 34.8579 33.6861Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M35.6756 33.5774C35.7255 33.5463 35.7472 33.4729 35.7212 33.4129C35.6951 33.3528 35.6344 33.3284 35.5845 33.3595C35.5346 33.3906 35.5129 33.464 35.5389 33.524C35.565 33.5841 35.6257 33.6085 35.6756 33.5774Z",
    fill: "#231F20"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6693 33.5594C35.7192 33.5283 35.7409 33.4549 35.7148 33.3949C35.6888 33.3349 35.628 33.3104 35.5781 33.3416C35.5282 33.3727 35.5065 33.446 35.5326 33.5061C35.5586 33.5661 35.6194 33.5906 35.6693 33.5594Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M36.3967 33.5594C36.4466 33.5283 36.4683 33.4571 36.4423 33.3971C36.4162 33.3371 36.3576 33.3148 36.3056 33.3437C36.2535 33.3727 36.234 33.446 36.26 33.5061C36.2861 33.5661 36.3446 33.5883 36.3967 33.5594Z",
    fill: "#231F20"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3894 33.5417C36.4393 33.5106 36.461 33.4394 36.4349 33.3794C36.4089 33.3194 36.3503 33.2971 36.2983 33.326C36.2462 33.355 36.2267 33.4283 36.2527 33.4884C36.2787 33.5484 36.3373 33.5706 36.3894 33.5417Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M31.7505 44.3693C31.8048 44.3337 31.8265 44.2581 31.7983 44.2003C31.77 44.1425 31.7071 44.1247 31.6529 44.1603C31.5986 44.1959 31.5769 44.2715 31.6052 44.3293C31.6334 44.3871 31.6963 44.4049 31.7505 44.3693Z",
    fill: "#231F20"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7378 44.385C31.7921 44.3495 31.8138 44.2739 31.7856 44.216C31.7573 44.1582 31.6944 44.1405 31.6402 44.176C31.5859 44.2116 31.5643 44.2872 31.5925 44.345C31.6207 44.4028 31.6836 44.4206 31.7378 44.385Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M31.3015 43.7112C31.3558 43.6757 31.3775 43.6001 31.3492 43.5423C31.321 43.4844 31.256 43.4644 31.2017 43.5C31.1475 43.5356 31.1258 43.6112 31.154 43.6712C31.1822 43.7312 31.2473 43.749 31.3015 43.7135V43.7112Z",
    fill: "#231F20"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2883 43.7247C31.3426 43.6891 31.3643 43.6135 31.3361 43.5557C31.3079 43.4979 31.2428 43.4779 31.1885 43.5134C31.1343 43.549 31.1126 43.6246 31.1408 43.6846C31.169 43.7447 31.2341 43.7624 31.2883 43.7269V43.7247Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M30.9456 42.9953C30.9999 42.9598 31.0216 42.8842 30.9955 42.8241C30.9695 42.7641 30.9022 42.7463 30.848 42.7819C30.7938 42.8175 30.7721 42.8931 30.7981 42.9531C30.8241 43.0131 30.8914 43.0309 30.9456 42.9953Z",
    fill: "#231F20"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M30.931 43.0086C30.9852 42.9731 31.0069 42.8975 30.9809 42.8374C30.9548 42.7774 30.8876 42.7596 30.8333 42.7952C30.7791 42.8308 30.7574 42.9064 30.7834 42.9664C30.8095 43.0264 30.8767 43.0442 30.931 43.0086Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M30.6492 42.095C30.7035 42.0594 30.7252 41.9838 30.6991 41.9238C30.6731 41.8638 30.6058 41.8437 30.5516 41.8793C30.4974 41.9149 30.4757 41.9905 30.5017 42.0505C30.5277 42.1105 30.595 42.1306 30.6492 42.095Z",
    fill: "#231F20"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6341 42.1105C30.6883 42.0749 30.71 41.9993 30.684 41.9393C30.658 41.8793 30.5907 41.8592 30.5365 41.8948C30.4822 41.9304 30.4605 42.006 30.4866 42.066C30.5126 42.126 30.5799 42.1461 30.6341 42.1105Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M30.4638 41.2522C30.518 41.2166 30.5397 41.141 30.5137 41.081C30.4877 41.021 30.4204 41.001 30.364 41.0365C30.3076 41.0721 30.2881 41.1477 30.3141 41.2077C30.3401 41.2678 30.4074 41.2878 30.4638 41.2522Z",
    fill: "#231F20"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4492 41.2678C30.5034 41.2323 30.5251 41.1567 30.4991 41.0966C30.473 41.0366 30.4058 41.0166 30.3494 41.0522C30.2929 41.0877 30.2734 41.1633 30.2995 41.2234C30.3255 41.2834 30.3927 41.3034 30.4492 41.2678Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8115 34.5444C38.8115 34.5444 38.8202 34.0619 39.2433 33.9997C39.2433 33.9997 39.3626 33.9885 39.4364 34.0019C39.4364 34.0019 39.5058 33.6728 39.7813 33.615C39.7813 33.615 40.0807 33.4461 40.3802 33.8551C40.3802 33.8551 40.5234 34.0241 40.5819 34.5222C40.5819 34.5222 40.6817 35.1491 40.4886 35.2514C40.4886 35.2514 40.3454 35.4115 40.2066 35.3448C40.2066 35.3448 40.2804 35.8628 40.5472 36.1274C40.5472 36.1274 40.8076 35.8539 41.2176 36.0896C41.2176 36.0896 41.5908 36.2719 41.6798 36.7855C41.6798 36.7855 41.7036 36.9767 41.6798 37.3747C41.6798 37.3747 41.6646 37.8594 41.6754 38.0262C41.6863 38.1907 41.6928 38.4041 41.7622 38.7576C41.7622 38.7576 41.7774 38.4753 41.9575 38.4152C41.9575 38.4152 42.2222 38.313 42.4022 38.6331C42.4022 38.6331 42.5541 38.8399 42.5953 39.1601C42.6387 39.4802 42.6691 39.5225 42.6431 39.8471C42.6431 39.8471 42.6474 40.205 42.5129 40.4051C42.3784 40.6075 42.3046 40.6897 42.0443 40.7297C42.0443 40.7297 42.0377 41.3056 41.5301 41.6813C41.0159 42.0593 40.8249 41.9015 40.8249 41.9015C40.8249 41.9015 40.8813 42.4062 40.3736 42.7486C39.9831 43.0109 39.7965 42.8175 39.7965 42.8175C39.8551 43.0087 39.5579 43.8447 38.9894 43.5868C38.9894 43.5868 39.1565 44.0737 38.5403 44.5028C38.5403 44.5028 38.1736 44.7118 37.9567 44.4161C37.9567 44.4161 37.9697 45.092 37.488 45.6723C37.488 45.6723 37.1019 46.2103 36.7308 46.008C36.7308 46.008 36.6527 46.8573 36.0062 47.133C35.3531 47.4109 35.0581 46.9196 35.0581 46.9196C35.0581 46.9196 34.7934 46.7106 34.4701 45.6144C34.4701 45.6144 34.2531 44.9852 34.2379 44.5495C34.2379 44.5495 33.8322 45.4855 33.3484 45.8012C33.3484 45.8012 32.6888 46.3504 32.1117 45.8924C32.1117 45.8924 31.8166 45.7345 31.617 45.1609C31.617 45.1609 31.4695 44.5561 31.6214 44.4027C31.7733 44.2515 31.7754 44.1982 32.1746 44.2204C32.1746 44.2204 32.3764 44.2715 32.8125 43.858C32.8125 43.858 33.0642 43.6401 33.3766 43.1688C33.3766 43.1688 33.8648 42.4906 34.1164 42.3172C34.3681 42.1438 34.7066 42.2705 34.7066 42.2705C34.7066 42.2705 34.9496 42.4373 35.006 42.5529C35.006 42.5529 35.1514 42.7419 35.1709 42.5329C35.1709 42.5329 35.1644 42.4617 35.0949 42.3172C35.0949 42.3172 34.9539 42.0126 35.1514 41.797C35.3488 41.5813 35.5679 41.6169 35.5679 41.6169C35.5679 41.6169 35.8673 41.6124 35.8587 41.3968C35.85 41.1789 35.5354 41.0321 35.5354 41.0321C35.5354 41.0321 34.8346 40.7431 34.5699 40.085C34.303 39.4224 34.5352 38.9533 34.7652 38.6798C34.7652 38.6798 33.9212 37.8149 34.2271 36.8278C34.2271 36.8278 34.4462 35.7539 35.4529 35.914C35.4529 35.914 35.9997 35.9896 36.1993 36.7477C36.1993 36.7477 36.3056 36.701 36.4271 36.7611C36.4271 36.7611 36.3512 36.6254 36.5594 36.4076C36.5594 36.4076 36.7699 36.2408 36.9022 36.3031C36.9022 36.3031 36.7894 35.994 37.0216 35.7939C37.0216 35.7939 37.0953 35.6383 37.462 35.6516C37.462 35.6516 37.705 35.1869 38.1541 35.4737C38.1541 35.4737 38.0066 34.7267 38.8137 34.5355L38.8115 34.5444Z",
    fill: "#111D2A"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9507 45.1231C31.9507 45.1231 32.2826 45.8612 32.7513 45.6611C33.2156 45.461 33.6994 44.8252 33.8947 44.4494C34.0899 44.0759 34.4371 43.5356 34.4371 43.5356L34.7018 44.3583C34.7018 44.3583 34.9838 46.1658 35.0576 46.3104C35.1314 46.4549 35.5371 47.1241 35.9949 46.6861C36.4505 46.2503 36.6067 45.6078 36.6067 45.6078C36.6067 45.6078 37.0862 45.9502 37.3813 45.2142C37.6763 44.4805 37.8152 43.0776 37.8152 43.0776L38.1059 43.7535C38.1059 43.7535 38.1992 44.1248 38.3901 44.0514C38.5811 43.9781 38.772 43.9558 38.7676 43.7668C38.7611 43.5779 38.6006 43.0754 38.6071 42.6129C38.6071 42.6129 38.772 42.9442 38.8523 43.0198C38.9325 43.0954 39.1126 43.3933 39.4511 43.0665C39.7895 42.7397 39.6485 42.5062 39.6485 42.5062C39.6485 42.5062 40.039 42.6841 40.4578 42.1838C40.8483 41.7169 40.7203 41.4723 40.7203 41.4723C40.7203 41.4723 41.1564 41.5924 41.4515 41.2522C41.8051 40.8454 41.8116 40.6764 41.816 40.3562C41.816 40.3562 42.0438 40.5541 42.2586 40.3762C42.4734 40.1984 42.482 39.8026 42.469 39.5914C42.469 39.5914 42.4669 38.9644 42.2304 38.7599L41.9483 39.5736C41.9483 39.5736 41.6272 38.811 41.5708 38.0728C41.5144 37.3347 41.5187 37.2102 41.5187 37.2102C41.5187 37.2102 41.5773 36.7322 41.2584 36.4631L41.2323 39.0978L41.2866 39.7048C41.2866 39.7048 41.1108 39.2735 40.9915 39.2401C40.87 39.209 40.5446 39.0956 40.5446 39.0956L40.2321 40.3429L40.2213 40.6475C40.2213 40.6475 39.974 40.1583 39.872 40.0916C39.7678 40.0272 39.3513 40.2784 39.3513 40.2784L39.2645 41.3968L39.1191 41.9192C39.1191 41.9192 39.0454 41.5746 39.0389 41.4523C39.0345 41.3723 38.9369 41.0677 38.8132 40.981C38.6895 40.8921 38.1385 41.2367 38.1385 41.2367C38.1385 41.2367 38.0777 40.6341 38.0886 40.4096C38.0994 40.1872 38.1818 39.9204 37.8412 39.5514L37.4463 40.4429L37.3704 42.0326L37.3335 42.9309L36.8562 44.5539C36.8562 44.5539 36.5937 43.5823 36.5807 43.3866C36.5676 43.1888 36.4136 42.3461 36.1055 42.0771L36.1619 45.2142L35.8061 45.8768L35.6868 45.7945C35.6868 45.7945 35.3245 44.7073 35.2962 44.1404C35.2702 43.5734 35.1704 43.0131 34.9231 42.7708L34.2809 42.8108L33.4542 43.9047L32.7035 44.8585L31.955 45.1164L31.9507 45.1231Z",
    fill: "url(#paint26_linear_1337_9822)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2066 38.6843C41.9831 38.5353 41.918 38.8399 41.918 38.8399C41.918 38.8399 41.9094 38.9222 41.9528 39.2045C41.9528 39.2045 41.9788 39.5647 41.9029 39.5002C41.8269 39.4358 41.8508 39.438 41.6946 39.0311C41.5188 38.5686 41.3474 37.7905 41.3605 37.0723C41.3605 37.0723 41.38 36.6343 41.2867 36.5032C41.1218 36.2741 40.818 36.3031 40.818 36.3031C40.818 36.3031 40.6098 36.3119 40.6033 36.6099C40.5989 36.8811 40.7313 37.9394 40.8376 38.3196C40.9157 38.5976 40.9895 38.9066 40.9895 38.9066C40.9895 38.9066 41.1283 39.2979 41.1956 39.4647C41.239 39.5714 41.3691 40.0516 41.1891 40.3496C41.048 40.5808 40.9504 40.5941 40.8853 40.5408C40.8853 40.5408 40.8875 40.5208 40.9287 40.4674C40.9699 40.414 41.1825 40.0316 41.1522 39.6981C41.1261 39.4024 40.9352 38.9022 40.6206 38.9466C40.6206 38.9466 40.3038 38.9377 40.1259 39.4291C40.1259 39.4291 39.9459 39.7448 40.0977 40.254C40.0977 40.254 40.2908 40.792 40.1346 41.3056C40.1346 41.3056 40.0674 41.5346 39.9111 41.5835C39.7419 41.6347 39.8873 41.4501 39.8873 41.4501C39.8873 41.4501 40.0825 41.0566 40.076 40.7253C40.0695 40.3762 39.9415 40.1872 39.8265 40.0494C39.8265 40.0494 39.5662 39.7581 39.2668 40.0672C39.0281 40.314 38.9023 40.7853 39.039 41.3656C39.039 41.3656 39.1279 42.2261 39.078 42.1616C38.9739 42.0237 38.95 41.6991 38.95 41.6991C38.95 41.6991 38.9088 41.4101 38.8871 41.2678C38.8654 41.1255 38.8372 41.0566 38.8111 40.9988C38.7656 40.8965 38.5356 40.8787 38.3859 40.9321C38.2948 40.9654 38.1169 40.9676 38.0388 41.5591C38.0388 41.5591 37.9954 41.648 37.9476 40.8943C37.8999 40.1383 37.9173 39.8582 37.9173 39.8582C37.9173 39.8582 37.8956 39.6292 37.8218 39.5358C37.7003 39.3868 37.3814 39.3624 37.3814 39.3624C37.3814 39.3624 37.121 39.3957 37.1362 39.6581C37.1514 39.9182 37.1731 40.1872 37.1731 40.1872C37.1731 40.1872 37.1969 40.145 36.8997 40.0716C36.4679 39.9649 36.4788 40.4274 36.5352 40.4941C36.5352 40.4941 36.8129 40.9009 36.878 41.1211C36.9431 41.3434 37.1405 41.8548 37.0386 42.6374C37.0386 42.6374 37.0451 43.1576 36.8889 44.167C36.8889 44.167 36.865 44.7029 36.8238 44.6162C36.7413 44.4405 36.6741 44.4628 36.5005 43.6668C36.2987 42.7441 36.3031 42.0571 35.8539 41.8926C35.3419 41.7036 35.2898 42.1727 35.3115 42.2283C35.3311 42.2839 35.4808 42.4573 35.6066 42.7063C35.7585 43.002 35.9147 43.9403 35.9364 44.5873C35.9537 45.1253 35.9537 45.4099 35.8127 45.7301C35.8127 45.7301 35.65 45.948 35.522 45.5811C35.19 44.6184 35.0902 43.6846 35.0902 43.6846C35.0902 43.6846 35.0143 42.9553 34.9167 42.7775C34.7583 42.4929 34.3851 42.3639 33.9924 42.7174C33.6843 42.9931 33.1918 43.7402 33.1918 43.7402C32.8902 44.2004 32.5149 44.6206 32.0788 44.485C31.8011 44.3983 31.8206 44.8741 31.8206 44.8741C31.8206 44.8741 32.0159 45.5767 32.5865 45.3721C33.079 45.1942 33.5433 44.4427 33.5433 44.4427L34.2332 43.2955C34.2332 43.2955 34.3764 43.0198 34.396 43.2243C34.422 43.4978 34.4307 43.8424 34.5392 44.4539C34.6042 44.8252 34.5847 45.0986 34.8689 45.9791C35.0165 46.4349 35.3484 46.6661 35.6695 46.5194C36.021 46.357 36.3204 46.1369 36.4311 45.3454C36.4311 45.3454 36.7131 45.65 37.0559 45.2409C37.3987 44.8341 37.5463 43.5645 37.5463 43.5645C37.5463 43.5645 37.633 43.0109 37.6439 42.7108C37.6439 42.7108 37.6981 42.9953 38.0453 43.729C38.0453 43.729 38.119 43.8024 38.2167 43.798C38.5898 43.7802 38.6029 43.5112 38.6029 43.5112C38.6029 43.5112 38.4879 43.1821 38.4293 42.315C38.4293 42.315 38.5226 42.7641 38.8589 42.9464C39.2017 43.1332 39.5011 42.5529 39.4859 42.2394C39.4859 42.2394 39.7072 42.3906 40.0543 42.1416C40.3993 41.8948 40.5534 41.5746 40.5664 41.2122C40.5664 41.2122 40.766 41.3523 41.1869 41.0677C41.1869 41.0677 41.623 40.8209 41.6468 40.0961C41.6468 40.0961 41.9484 40.3029 42.1545 40.0694C42.3607 39.8337 42.3173 39.2823 42.3173 39.2823C42.3173 39.2823 42.2717 38.7376 42.2044 38.6909L42.2066 38.6843ZM39.5683 40.7631C39.538 40.4674 39.6378 40.3584 39.6378 40.3584C39.6378 40.3584 39.7983 40.2073 39.8374 40.6719C39.8764 41.1344 39.6378 41.3145 39.6378 41.3145C39.6378 41.3145 39.5965 41.0588 39.5662 40.7631H39.5683ZM40.8289 39.3468C40.933 39.4558 40.9916 39.5069 40.9417 39.8893C40.8896 40.294 40.7356 40.2984 40.7356 40.2984C40.6705 40.2517 40.6119 39.1156 40.8289 39.3468Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0696 38.7709C41.9936 38.7931 42.0153 38.9288 42.0153 38.9288C42.0153 38.9288 42.113 39.2623 42.0066 39.5691C42.0066 39.5691 41.9502 39.7447 41.8765 39.6803C41.8027 39.6158 41.7376 39.4979 41.5923 39.0977C41.4469 38.6953 41.1844 37.5281 41.2581 36.8611C41.2581 36.8611 41.2972 36.6721 41.1952 36.5565C41.0932 36.4408 40.7895 36.4586 40.7895 36.4586C40.7895 36.4586 40.6984 36.472 40.7005 36.6543C40.7049 36.9233 40.924 38.2306 40.9934 38.5019C41.065 38.7754 41.2147 39.2289 41.2147 39.2289C41.2147 39.2289 41.3558 39.5068 41.3796 39.6892C41.3948 39.807 41.4317 40.3384 41.1995 40.5874C40.9674 40.8364 40.7483 40.743 40.7569 40.534C40.7569 40.534 40.7461 40.5229 40.7852 40.4718C40.8242 40.4206 41.0368 40.0693 41.0455 39.7803C41.0542 39.4891 40.885 39.0377 40.5769 39.08C40.5769 39.08 40.297 39.1355 40.1842 39.6069C40.1842 39.6069 40.1256 39.8715 40.2232 40.3406C40.2232 40.3406 40.4792 41.1899 40.0844 41.5901C40.0844 41.5901 39.913 41.8191 39.7719 41.6857C39.6309 41.5523 39.6982 41.4901 39.6982 41.4901C39.6982 41.4901 39.9759 41.0721 39.9694 40.7475C39.9629 40.4051 39.8674 40.2783 39.7546 40.1427C39.7546 40.1427 39.5615 39.9271 39.3207 40.1538C39.0798 40.3806 39.0733 40.8942 39.0733 40.8942C39.0733 40.8942 39.0495 41.0343 39.1579 41.4634C39.1579 41.4634 39.2252 41.8858 39.197 42.0326C39.1709 42.1793 39.1471 42.3883 39.0256 42.2949C38.9063 42.2015 38.8347 41.6857 38.8347 41.6857C38.8347 41.6857 38.7891 41.3633 38.7674 41.2255C38.7457 41.0876 38.7066 41.0187 38.6524 41.0276C38.5982 41.0365 38.3964 41.061 38.3964 41.061C38.3964 41.061 38.2402 41.0387 38.1859 41.3055C38.1317 41.5723 38.1013 41.9948 38.1512 42.5306C38.1512 42.5306 37.8909 41.6791 37.8431 40.9409C37.7954 40.2028 37.8128 39.8426 37.8128 39.8426C37.8128 39.8426 37.8301 39.6869 37.7455 39.6091C37.6587 39.5313 37.4049 39.4779 37.4049 39.4779C37.4049 39.4779 37.227 39.4602 37.2422 39.7136C37.2573 39.9671 37.3138 40.5029 37.3138 40.5029C37.3138 40.5029 37.1575 40.2739 36.869 40.205C36.6477 40.1516 36.5826 40.265 36.6151 40.4095C36.6151 40.4095 36.9471 40.9298 37.01 41.1455C37.0729 41.3611 37.2443 41.9258 37.1445 42.6885C37.1445 42.6885 37.099 43.7512 36.9471 44.7339C36.9471 44.7339 36.8863 44.9407 36.8061 44.8584C36.7236 44.7762 36.5392 44.4671 36.3852 43.6356C36.2311 42.7996 36.166 42.2149 35.8254 42.0281C35.4826 41.8391 35.3958 42.1015 35.4153 42.1571C35.4349 42.2127 35.5954 42.4172 35.7147 42.6507C35.8709 42.953 36.0727 44.0625 36.064 44.5894C36.0575 45.1164 36.0901 45.7256 35.8015 45.9323C35.8015 45.9323 35.6193 46.0969 35.4414 45.7189C35.066 44.9296 34.9597 43.5622 34.9597 43.5622C34.9597 43.5622 34.9076 43.0531 34.8122 42.8819C34.6581 42.604 34.426 42.5506 34.1049 42.7796C33.7838 43.0086 33.3195 43.7379 33.3195 43.7379C33.3195 43.7379 32.9984 44.2537 32.5775 44.5761C32.5775 44.5761 32.341 44.725 32.124 44.6294C31.907 44.5338 31.9461 44.8562 31.9461 44.8562C31.9461 44.8562 32.0654 45.4143 32.5514 45.2498C33.0331 45.0875 33.5169 44.2759 33.5169 44.2759L34.2177 43.1109C34.2177 43.1109 34.4347 42.8018 34.4932 43.0575C34.5496 43.3132 34.5388 43.7534 34.6451 44.3471C34.7102 44.7095 34.6885 45.0452 34.9662 45.9034C35.1094 46.3459 35.3763 46.5037 35.6909 46.3592C36.0337 46.2014 36.3309 45.8923 36.3526 45.0408C36.3526 45.0408 36.6238 45.5588 36.9601 45.1586C37.2942 44.7606 37.4613 43.3977 37.4613 43.3977C37.4613 43.3977 37.6001 42.2505 37.585 41.9481C37.585 41.9481 37.7455 42.9241 38.1057 43.6178C38.1057 43.6178 38.1143 43.6712 38.2098 43.6467C38.3053 43.62 38.4636 43.5645 38.4636 43.5645L38.481 43.4777C38.481 43.4777 38.1924 42.4995 38.3725 41.5946C38.3725 41.5946 38.5287 42.6395 38.878 42.7907C39.2252 42.9397 39.3554 42.4194 39.3554 42.4194C39.3554 42.4194 39.4053 42.3038 39.3923 41.997C39.3923 41.997 39.6179 42.3038 39.9585 42.0615C40.297 41.8213 40.3946 41.499 40.3946 41.499C40.3946 41.499 40.4706 41.2877 40.4836 40.9365C40.4836 40.9365 40.7418 41.3722 41.193 40.8898C41.193 40.8898 41.627 40.5829 41.5532 39.8292C41.5532 39.8292 41.9025 40.2294 42.0978 39.9693C42.293 39.7092 42.2193 39.3067 42.2193 39.3067C42.2193 39.3067 42.1997 38.9844 42.1564 38.822C42.1564 38.822 42.139 38.7376 42.0631 38.7598L42.0696 38.7709ZM39.5159 40.7942C39.4855 40.5051 39.5832 40.4006 39.5832 40.4006C39.5832 40.4006 39.7416 40.2539 39.7784 40.7075C39.8153 41.1588 39.5832 41.3344 39.5832 41.3344C39.5832 41.3344 39.5441 41.0854 39.5138 40.7964L39.5159 40.7942ZM40.7461 39.4112C40.8481 39.518 40.9067 39.5669 40.8567 39.9404C40.8047 40.3362 40.655 40.3406 40.655 40.3406C40.5899 40.2939 40.5335 39.1867 40.7461 39.4112Z",
    fill: "url(#paint27_linear_1337_9822)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1456 33.8463C40.1456 33.8463 40.3777 34.1376 40.3647 34.331C40.3647 34.331 40.3734 34.4444 40.3994 34.6023C40.4081 34.6623 40.4949 34.8446 40.3495 34.9247C40.2237 34.9936 40.0523 35.087 39.9872 34.998C39.9872 34.998 40.0414 35.6339 40.0848 35.7962C40.0848 35.7962 40.1911 36.0853 40.1022 36.1564C40.1022 36.1564 39.933 36.3343 39.7268 36.2164C39.7268 36.2164 39.7051 36.232 39.703 36.2698C39.69 36.4899 39.0716 37.4904 38.5986 36.5877L38.8677 36.441L38.9978 36.3521L39.2777 36.2876L39.512 35.6117L39.627 35.1359L40.1434 33.8441L40.1456 33.8463Z",
    fill: "url(#paint28_linear_1337_9822)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8018 39.8715C34.8018 39.8715 35.0426 40.3251 35.2335 40.4341C35.4223 40.543 35.7694 40.6631 36.2879 40.1006C36.8022 39.5425 36.5852 38.9689 36.5852 38.9689C36.5852 38.9689 36.813 39.209 37.0582 38.9311C37.3033 38.6532 37.2339 38.4575 37.2339 38.4575C37.2339 38.4575 37.4986 38.7199 37.8067 38.1351L38.2254 39.3824C38.2254 39.3824 38.4511 39.8115 38.6181 39.667C38.783 39.5225 38.9219 39.2557 38.8546 39.0778C38.7874 38.9022 38.6702 38.7599 38.6702 38.7599C38.6702 38.7599 38.2233 38.0484 38.1625 37.7505C38.1625 37.7505 38.7852 37.7505 38.5964 36.5588L38.2862 36.1185L38.2775 37.1479L37.7915 37.5237L37.2296 37.9417L36.6763 38.6109L36.2619 38.6709C36.2619 38.6709 36.2272 39.6915 35.9885 39.727C35.7499 39.7626 34.8039 39.8738 34.8039 39.8738L34.8018 39.8715Z",
    fill: "url(#paint29_linear_1337_9822)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M35.126 37.7015C35.126 37.7015 34.831 36.9166 35.3256 37.0256C35.816 37.1323 35.356 36.5698 35.356 36.5698C35.356 36.5698 34.9958 36.2474 34.768 36.512C34.5402 36.7766 34.7311 37.3013 34.7311 37.3013L35.126 37.7037V37.7015Z",
    fill: "url(#paint30_linear_1337_9822)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4001 37.5926C35.4001 37.5926 35.5976 38.0172 35.7473 38.0395C35.897 38.0639 36.1291 38.1951 36.1269 37.846C36.1248 37.497 36.1313 36.9745 35.7841 36.5187C35.4348 36.0585 35.7408 37.0034 35.7408 37.0034L35.6887 37.4659L35.3979 37.5926H35.4001Z",
    fill: "url(#paint31_linear_1337_9822)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4395 37.0613C36.4395 37.0613 36.6759 37.3014 36.6673 37.4948C36.6586 37.6883 36.7714 38.0929 36.8213 38.0996C36.8712 38.1063 36.8061 38.4575 36.715 38.3864C36.626 38.3152 36.3093 37.248 36.4373 37.0613H36.4395Z",
    fill: "url(#paint32_linear_1337_9822)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M37.099 36.6432C37.099 36.6432 37.2726 36.8455 37.3138 36.9456C37.355 37.0456 37.4375 37.5459 37.4375 37.5459L37.3073 37.7371C37.3073 37.7371 36.9537 37.1034 37.099 36.6432Z",
    fill: "url(#paint33_linear_1337_9822)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9859 36.4831C37.9859 36.4831 37.8926 36.7344 37.9338 37.1146L37.8622 37.2502L37.5889 36.9767L37.7169 36.1141C37.7169 36.1141 37.7429 35.4782 37.9859 36.4831Z",
    fill: "url(#paint34_linear_1337_9822)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8349 35.2847C38.8349 35.2847 38.925 35.4581 38.8349 35.6871C38.8349 35.6871 38.7791 35.487 38.8349 35.2847Z",
    fill: "url(#paint35_linear_1337_9822)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M35.207 38.8577C35.207 38.8577 35.4153 39.0578 35.4088 39.2534C35.4023 39.4491 35.4696 39.6914 35.4696 39.6914C35.4696 39.6914 35.1506 39.5958 35.1159 39.5002C35.0812 39.4046 35.207 38.8577 35.207 38.8577Z",
    fill: "url(#paint36_linear_1337_9822)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9733 38.9733C35.9733 38.9733 35.7129 38.7888 35.522 38.7465C35.292 38.6932 34.8863 38.5731 34.6216 38.0328L34.8103 38.0951L35.6023 38.3085C35.6023 38.3085 36.1165 38.7977 35.9733 38.9733Z",
    fill: "url(#paint37_linear_1337_9822)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M39.054 35.0046C39.054 35.0046 39.2341 35.2114 39.3187 35.4871C39.4033 35.7628 39.3078 36.0696 39.3078 36.0696L39.0909 36.4098L38.8066 36.1074L39.0366 35.6939L39.054 35.0046Z",
    fill: "url(#paint38_linear_1337_9822)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0407 33.7907C40.0407 33.7907 39.852 33.7663 39.7543 33.8285C39.6567 33.8908 39.6155 33.9153 39.5808 34.062C39.5569 34.1598 39.5395 34.2599 39.5395 34.2599C39.5395 34.2599 39.5157 34.2688 39.4853 34.2287C39.4115 34.1331 39.1924 34.2065 39.1924 34.2065C39.1924 34.2065 38.9863 34.2287 39.0383 34.46C39.0622 34.5711 39.1729 34.9891 39.2228 35.1359C39.2705 35.2826 39.3508 35.4383 39.3096 35.7006C39.2748 35.9274 39.2271 36.0096 39.1425 36.1141C39.1056 36.1586 38.9971 36.2631 38.9841 36.1431C38.9841 36.1431 39.0123 36.0697 39.0405 36.0386C39.1273 35.9429 39.2076 35.6962 39.1924 35.3738C39.175 35.0069 38.8821 34.6556 38.5979 34.8379C38.3289 35.0091 38.3115 35.4205 38.3115 35.4205C38.3115 35.4205 38.2746 35.6806 38.3441 35.9874C38.2161 35.6272 38.1054 35.625 37.9666 35.5939C37.7995 35.5561 37.6194 35.6739 37.589 35.8051C37.563 35.9163 37.5413 35.9074 37.5413 35.9074C37.563 35.8607 37.2571 35.7918 37.1117 35.9607C37.0358 36.0497 37.1052 36.2809 37.1052 36.2809C37.1052 36.2809 37.32 37.0191 37.3677 37.4726C37.3851 37.6438 37.3417 37.6371 37.2896 37.5238C37.2376 37.4104 37.1508 36.8301 37.1291 36.67C37.1052 36.4832 36.7776 36.5255 36.68 36.5988C36.552 36.6967 36.591 36.8012 36.591 36.8012C36.591 36.8012 36.7624 37.5393 36.7689 37.8573C36.7711 37.9795 36.8644 38.3419 36.7429 38.1441C36.6214 37.9462 36.5737 37.2992 36.5021 37.128C36.3871 36.8501 36.0421 37.0568 35.9813 37.1058C35.9097 37.1636 35.9575 37.2592 35.9575 37.2592L36.1658 38.1352C36.1658 38.1352 36.3393 38.9311 36.7733 38.8111C37.1009 38.7199 37.0792 38.2286 37.0792 38.2286C37.0792 38.2286 37.1877 38.3419 37.3113 38.2797C37.5934 38.1352 37.5999 37.9773 37.5999 37.9773C37.9015 38.8066 38.177 39.298 38.2877 39.4536C38.4113 39.6293 38.6218 39.2869 38.6782 39.1646C38.7867 38.9289 38.6847 38.7644 38.6847 38.7644C38.6847 38.7644 38.574 38.6554 38.4092 38.3531C38.0186 37.6305 38.0295 37.5415 38.0295 37.5415C38.1748 37.5482 38.2703 37.4571 38.3636 37.3059C38.4742 37.1258 38.5328 36.7923 38.4352 36.3209C38.4764 36.4232 38.5307 36.5166 38.6023 36.5922C38.9516 36.959 39.5157 36.5144 39.5894 35.9741C39.5894 35.9741 39.6046 36.0452 39.7326 36.0297C39.8606 36.0141 39.9149 35.9674 39.9149 35.9674C39.9149 35.9674 40.0385 35.8785 39.9995 35.794C39.9279 35.6384 39.8411 35.1759 39.8454 34.7423C39.8454 34.7423 39.8606 34.8335 39.9474 34.8068C40.0342 34.7801 40.2533 34.6845 40.2533 34.6845C40.2533 34.6845 40.3314 34.6223 40.2837 34.4177C40.262 34.3288 40.1817 33.9264 40.1817 33.9264C40.1817 33.9264 40.1817 33.833 40.0407 33.7974V33.7907ZM38.8301 35.2848C38.9212 35.4649 38.8387 35.6828 38.8387 35.6828C38.791 35.5205 38.8301 35.2848 38.8301 35.2848ZM38.0186 36.7856C38.0468 37.0302 38.0664 37.1636 37.9123 37.0613C37.7626 36.9612 37.8125 36.8923 37.8103 36.6855C37.8103 36.4988 37.8624 36.2075 37.8624 36.2075C37.8624 36.2075 37.96 36.3031 38.0186 36.7878V36.7856Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3678 37.3814C35.3678 37.3814 35.3721 36.93 35.2051 36.8233C34.8232 36.5787 34.7842 37.3102 35.1595 37.6815C35.4286 37.935 35.9319 38.144 36.0968 38.2618C36.2964 38.4041 36.3355 38.5086 36.4591 38.7999C36.4591 38.7999 36.5915 39.2623 36.3007 39.6581C36.0534 39.9938 35.8104 40.1605 35.8104 40.1605C35.8104 40.1605 35.4633 40.4273 35.0988 40.2272C34.8297 40.0227 34.7343 39.7759 34.7104 39.5825C34.7104 39.5758 34.6757 39.1978 34.8948 38.9266C34.8948 38.9266 35.1725 38.5909 35.2572 38.9666C35.2767 39.0578 35.2832 39.3112 35.2832 39.3112C35.2832 39.3112 35.2919 39.6247 35.5067 39.6848C35.767 39.7559 35.9145 39.4202 35.9145 39.4202C35.9145 39.4202 36.1055 39.0844 35.8364 38.7643C35.8364 38.7643 35.7779 38.6576 35.3244 38.5108C34.8666 38.3641 34.6562 38.0817 34.6562 38.0817C34.6562 38.0817 34.257 37.6926 34.4001 36.9278C34.4001 36.9278 34.4804 36.3319 34.91 36.1674C35.2962 36.0184 35.6325 36.263 35.7215 36.4186C35.7215 36.4186 35.9449 36.7677 35.9992 37.1857C36.0729 37.7638 35.8755 37.8816 35.754 37.8505C35.5956 37.8105 35.3548 37.7171 35.37 37.3791L35.3678 37.3814Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9341 35.707C37.7757 35.6714 37.6542 35.8159 37.6239 35.9382C37.5935 36.0716 37.5956 36.4007 37.5956 36.4007C37.5956 36.4007 37.5457 36.1828 37.5262 36.0605C37.5067 35.9382 37.2659 35.9849 37.2051 36.0094C37.1162 36.045 37.1899 36.2406 37.1899 36.2406C37.1899 36.2406 37.5262 37.2678 37.4026 37.6435C37.3505 37.8014 37.2724 37.728 37.2225 37.6213C37.1726 37.5124 37.0858 36.9054 37.0706 36.7542C37.0554 36.603 36.769 36.6808 36.7061 36.7008C36.6432 36.7209 36.6779 36.8231 36.6779 36.8231C36.6779 36.8231 36.8862 37.7614 36.8775 38.0482C36.8732 38.166 36.8276 38.4706 36.7126 38.2839C36.5976 38.0971 36.4501 37.3879 36.4306 37.2055C36.411 37.0232 36.129 37.1411 36.0899 37.17C36.0335 37.21 36.0617 37.3011 36.0617 37.3011L36.2635 38.0927C36.2635 38.0927 36.4262 38.833 36.7408 38.7374C37.0554 38.6441 37.0272 37.9815 37.0272 37.9815C37.0272 37.9815 37.0858 38.2861 37.3288 38.1949C37.626 38.086 37.5696 37.5857 37.5696 37.5857C37.8191 38.4462 38.2314 39.1954 38.3333 39.3444C38.4353 39.4934 38.5655 39.1376 38.6241 39.0242C38.6805 38.9109 38.5221 38.753 38.5221 38.753C38.5221 38.753 38.431 38.673 38.2791 38.375C37.9276 37.6769 37.856 37.3545 37.856 37.3545C38.0101 37.4368 38.1988 37.3812 38.2878 37.2367C38.4028 37.0521 38.4635 36.832 38.3398 36.334C38.2118 35.8137 38.0925 35.747 37.9341 35.7115V35.707ZM38.0925 36.6919C38.1532 37.2411 38.0925 37.2967 37.9211 37.19C37.7497 37.0833 37.7063 36.9654 37.715 36.7876C37.7323 36.394 37.8213 35.9227 37.8213 35.9227C37.8213 35.9227 38.0383 36.1761 38.0925 36.6919ZM35.4521 37.3367C35.4521 37.3367 35.4477 36.8098 35.196 36.6964C34.8771 36.5519 34.8012 36.9921 34.8012 36.9921C34.8012 36.9921 34.7665 37.2611 34.9921 37.6347C35.2004 37.9548 35.8252 38.2038 35.9815 38.3128C36.1724 38.4462 36.2548 38.5573 36.372 38.833C36.372 38.833 36.5 39.1176 36.3026 39.4978C36.0726 39.9403 35.7102 40.1137 35.7102 40.1137C35.7102 40.1137 35.3392 40.3316 35.0246 40.0403C34.799 39.8536 34.7686 39.5245 34.7882 39.4133C34.7882 39.4067 34.7925 39.1287 34.9964 38.962C34.9964 38.962 35.1331 38.8486 35.1635 38.9309C35.1917 39.0065 35.1939 39.3555 35.1939 39.4089C35.1939 39.4133 35.1939 39.4178 35.1939 39.4222C35.2069 39.4778 35.298 39.8358 35.5801 39.8158C35.8534 39.7957 36.0357 39.4133 36.0357 39.4133C36.0357 39.4133 36.1398 38.9864 35.912 38.7085C35.912 38.7085 35.784 38.5373 35.3523 38.4039C34.8836 38.2928 34.7057 38.0148 34.7057 38.0148C34.7057 38.0148 34.3694 37.6102 34.4844 36.9143C34.4844 36.9143 34.6016 36.3918 34.9791 36.2762C35.3544 36.1606 35.6039 36.4074 35.6886 36.5541C35.6886 36.5541 35.8599 36.8565 35.9142 37.25C35.9641 37.6169 35.9012 37.7992 35.784 37.7703C35.6321 37.7325 35.4195 37.6902 35.4521 37.3412V37.3367ZM40.056 33.9239C40.056 33.9239 39.8564 33.8905 39.7609 33.9483C39.6655 34.0061 39.6091 34.2129 39.6047 34.3574C39.6004 34.5019 39.6243 35.0155 39.6243 35.0155C39.6243 35.0155 39.5375 34.7154 39.4984 34.4753C39.4789 34.353 39.4745 34.3241 39.3878 34.3152C39.2532 34.2996 39.1708 34.3419 39.1708 34.3419C39.1708 34.3419 39.0949 34.3552 39.1209 34.4575C39.1491 34.5598 39.2988 35.1 39.3444 35.2401C39.3899 35.3779 39.4442 35.7448 39.3509 35.9738C39.2554 36.2006 39.1035 36.334 39.0146 36.3229C38.9235 36.3118 38.8605 36.2473 38.8475 36.1317C38.8475 36.1317 38.8562 36.0983 38.8844 36.0672C38.9126 36.0361 39.1252 35.7648 39.1079 35.4602C39.0862 35.0778 38.8692 34.771 38.6002 34.9533C38.3919 35.0956 38.3767 35.498 38.3767 35.498C38.3767 35.498 38.342 36.2028 38.6761 36.5519C39.0081 36.8987 39.5939 36.1984 39.5288 35.7048C39.5288 35.7048 39.5722 35.956 39.6958 35.9405C39.8195 35.9249 39.8955 35.8826 39.8955 35.8826L39.9128 35.8159C39.9128 35.8159 39.685 34.8644 39.8022 34.3374L39.8694 34.6242C39.8694 34.6242 39.8889 34.7243 39.9714 34.6976C40.0538 34.6731 40.1862 34.6109 40.1862 34.6109C40.1862 34.6109 40.2383 34.5731 40.21 34.5264C40.1688 34.453 40.1146 34.0595 40.1146 34.0595C40.1146 34.0595 40.1059 33.9194 40.0473 33.9217L40.056 33.9239ZM38.7347 35.3602C38.7803 35.12 38.917 34.9822 38.956 35.4269C38.9712 35.6047 38.9018 35.9516 38.7868 35.9627C38.7868 35.9627 38.7 35.5514 38.7347 35.3602Z",
    fill: "url(#paint39_linear_1337_9822)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9582 40.0725L23.5623 38.4273L13.7109 36.7722L16.666 42.8575L24.4875 44.6162L25.4573 46.5928L17.6597 44.903L18.61 46.8618L28.319 49.2052L25.2382 42.9353L17.5056 41.3457L16.3948 39.06L23.9582 40.0725Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5131 30.7669L17.0755 31.1315L10.879 19.2143L8.29932 19.1654L14.5131 30.7669Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1134 14.5834L7.50417 15.6061L15.2042 10.5613L24.0432 9.6809L26.0957 8.13123L14.1736 9.5764L3.11719 17.0113L15.3908 16.122L17.1134 14.5834Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M36.683 1.55423L30.7404 1.59425C30.6297 1.59425 30.5212 1.6187 30.4214 1.66984L20.396 6.7578L29.896 6.34651L32.271 4.70135L30.8597 4.14443L32.8601 4.30006L36.6851 1.552L36.683 1.55423ZM31.3913 3.52189L29.3149 3.29289L30.8011 2.47914L33.2398 2.43467L31.3913 3.52189ZM28.4948 5.29168L25.5094 5.51179L27.2842 4.46459L30.2001 4.36232L28.4948 5.2939V5.29168Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0393 1.50321L30.4868 6.3012L36.4858 6.65694L46.2036 1.48987L38.0393 1.50098V1.50321ZM33.4939 5.50079L38.4276 2.25692L42.8819 2.23247L36.7766 5.64753L33.4961 5.49857L33.4939 5.50079Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1337_9822",
    x1: 39.1866,
    y1: 42.9419,
    x2: 42.8371,
    y2: 7.27033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#431413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#491312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#5B1111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#6A1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#711012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#841315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#A4171B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#D11C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#EB2027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#DA1E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#B11C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#981A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#8F1A1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#5D1617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#451515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#511414"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1337_9822",
    x1: 47.2751,
    y1: 23.4721,
    x2: 53.7132,
    y2: 38.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#E8E9EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#F4F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F8F9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F5F6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EDEEF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E0E1E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#CDCECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B5B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C9D9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1337_9822",
    x1: 24.2987,
    y1: 50.7149,
    x2: 32.0622,
    y2: 17.7878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#431413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#491312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#5B1111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#6A1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#711012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#841315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A4171B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#D11C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#EB2027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#DA1E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#B11C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#981A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#8F1A1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#5D1617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#451515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#511414"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1337_9822",
    x1: 31.044,
    y1: 31.2317,
    x2: 43.6527,
    y2: 50.7344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#E8E9EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#F4F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F8F9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F5F6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EDEEF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E0E1E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#CDCECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B5B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C9D9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1337_9822",
    x1: 35.2706,
    y1: 24.2993,
    x2: 35.0314,
    y2: -10.7585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#431413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#491312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#5B1111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#6A1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#711012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#841315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#A4171B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#D11C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#EB2027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#DA1E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#B11C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#981A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#8F1A1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#5D1617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#451515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#511414"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1337_9822",
    x1: 41.3977,
    y1: 3.85985,
    x2: 49.4162,
    y2: 22.8424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#E8E9EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F4F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F8F9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#F4F5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#D9DADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#C2C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#A3A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C9D9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1337_9822",
    x1: 20.6168,
    y1: 34.0376,
    x2: 17.9473,
    y2: -0.587959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#431413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#491312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#5B1111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#6A1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#711012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#841315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#A4171B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#D11C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EB2027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#DA1E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#B11C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#981A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#8F1A1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#5D1617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#451515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#511414"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1337_9822",
    x1: 20.7377,
    y1: 9.62535,
    x2: 34.7446,
    y2: 29.9004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#E8E9EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F4F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F8F9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#F5F6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EDEEF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#E0E1E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#CDCECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B5B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C9D9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1337_9822",
    x1: 46.5885,
    y1: 18.1999,
    x2: 45.0726,
    y2: 14.0731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#5A5757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1337_9822",
    x1: 47.8555,
    y1: 14.2599,
    x2: 45.4804,
    y2: 7.79396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#E8232A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D32128"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C82026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#B61F24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#AB1F23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A81F23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1337_9822",
    x1: 42.8327,
    y1: 15.0166,
    x2: 40.8883,
    y2: 9.80072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#E8232A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D32128"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#C82026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#B61F24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#AB1F23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A81F23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1337_9822",
    x1: 19.2223,
    y1: 24.2355,
    x2: 23.1033,
    y2: 21.6665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15A4DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#17A4DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#21A5DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#31A6DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#48A9DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CABDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1337_9822",
    x1: 20.8296,
    y1: 24.4727,
    x2: 25.5802,
    y2: 21.3281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69B5E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12ABDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1337_9822",
    x1: 22.5302,
    y1: 24.6497,
    x2: 24.5194,
    y2: 20.0507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126BA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2692D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1337_9822",
    x1: 26.8722,
    y1: 20.2746,
    x2: 29.705,
    y2: 18.3994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69B5E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12ABDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1337_9822",
    x1: 25.0894,
    y1: 21.5138,
    x2: 29.0506,
    y2: 18.8918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126BA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2692D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1337_9822",
    x1: 26.3859,
    y1: 21.8325,
    x2: 28.1614,
    y2: 20.6572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69B5E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12ABDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1337_9822",
    x1: 25.9421,
    y1: 20.0936,
    x2: 27.7559,
    y2: 18.8929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69B5E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12ABDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1337_9822",
    x1: 25.185,
    y1: 26.1894,
    x2: 34.1466,
    y2: 20.2575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69B5E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12ABDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1337_9822",
    x1: 25.4142,
    y1: 26.076,
    x2: 33.8399,
    y2: 20.4988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126BA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2692D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1337_9822",
    x1: 21.1188,
    y1: 19.2784,
    x2: 30.1078,
    y2: 13.3283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69B5E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12ABDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1337_9822",
    x1: 21.3561,
    y1: 19.0675,
    x2: 29.8164,
    y2: 13.4674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126BA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2692D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1337_9822",
    x1: 30.0519,
    y1: 40.3162,
    x2: 40.652,
    y2: 37.1786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A3449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#10425B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#18536D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#1C5C79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#1D607D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#287290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#2A7896"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#287290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#1E627D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#10465F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#0A3C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C2837"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1337_9822",
    x1: 30.8956,
    y1: 40.9076,
    x2: 40.1853,
    y2: 36.1825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D281B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#7E3522"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#A05032"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#BA653E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#CC7346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#D77D4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#DB804C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F1AA61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#B45F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#AC5935"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#873F28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#712F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68291A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1337_9822",
    x1: 33.0523,
    y1: 33.5596,
    x2: 36.5681,
    y2: 34.1851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D281B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#97492D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#DB804C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F1AA61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#B45F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#AC5935"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#873F28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#712F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68291A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1337_9822",
    x1: 31.0736,
    y1: 44.4895,
    x2: 31.1853,
    y2: 40.6988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D281B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#752D1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#883E28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#AA5836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#D67C4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#DB804C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F1AA61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#B45F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#AC5935"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#873F28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#712F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68291A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1337_9822",
    x1: 37.3227,
    y1: 37.855,
    x2: 37.1313,
    y2: 45.2896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4A222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F08829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#EC7533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#EA6936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#EA6638"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#E24E40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#6E1E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1337_9822",
    x1: 37.2139,
    y1: 36.7743,
    x2: 37.0248,
    y2: 44.8671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#2883A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#1D6C8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#135A79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#0D4E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#074B6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#0D4050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#12212E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F1B28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1337_9822",
    x1: 39.6617,
    y1: 33.9353,
    x2: 39.4226,
    y2: 36.6801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8B73D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#DC953F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#D27A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#CE683F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#C85C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#C85A41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E24E40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#6E1E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1337_9822",
    x1: 36.3075,
    y1: 35.3759,
    x2: 36.8014,
    y2: 38.7921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2B03A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#D08E37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#C27438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B96236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#B35636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#B25335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E24E40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6E1E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1337_9822",
    x1: 34.653,
    y1: 37.0545,
    x2: 35.5513,
    y2: 37.0545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5A620"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#F29527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#ED832D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#EB7735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#EB7536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E24E40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#6E1E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1337_9822",
    x1: 35.9555,
    y1: 36.8077,
    x2: 35.5533,
    y2: 38.5132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5A620"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#F29527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#ED832D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#EB7735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#EB7536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E24E40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#6E1E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1337_9822",
    x1: 36.6499,
    y1: 37.3748,
    x2: 36.4973,
    y2: 38.9593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5A620"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#F28F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#ED7D2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#EC7134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#EC6E34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#E24E40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#6E1E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1337_9822",
    x1: 37.2683,
    y1: 37.0812,
    x2: 37.1023,
    y2: 37.8243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5A620"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#F18F27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#ED7D2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#EB7234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#EA6F35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E24E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1337_9822",
    x1: 37.834,
    y1: 36.5409,
    x2: 37.2468,
    y2: 37.7795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4A520"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#F09228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#EC8030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E97436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#EA7236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#E24E40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#6E1E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1337_9822",
    x1: 38.8563,
    y1: 35.427,
    x2: 38.6303,
    y2: 35.9997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4A520"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#F09228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#EC8030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E97436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#EA7236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#E24E40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#6E1E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1337_9822",
    x1: 35.3481,
    y1: 39.2267,
    x2: 34.8709,
    y2: 41.1357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5A121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#EF8729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#EC7533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#EA6936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#E96538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#E24E40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#6E1E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1337_9822",
    x1: 35.1662,
    y1: 38.2374,
    x2: 36.3922,
    y2: 39.8115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5A620"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#F29527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#ED832D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#EB7735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#EB7536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E24E40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#6E1E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1337_9822",
    x1: 39.1928,
    y1: 35.5338,
    x2: 38.3594,
    y2: 36.6729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3A423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#EF9128"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EB7F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E97436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#E87139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#E24E40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#6E1E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1337_9822",
    x1: 37.4004,
    y1: 34.6465,
    x2: 37.127,
    y2: 40.3287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#1F6E8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#1F6C8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#135A79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#0D4E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#074B6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#0D4050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#12212E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#0F1B28"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllGames);
export default __webpack_public_path__ + "static/media/AllGames.78c010ad83c8498506d1bcda853cd24d.svg";
export { ForwardRef as ReactComponent };